/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/**
 * There will be one reducer file per common component
 */
import {
    SET_USER_DETAILS,
    SET_IS_AUTHENTICATED_WITH_HYBRIS,
    GET_HYBRIS_USER_DETAILS,
    GET_HYBRIS_USER_DETAILS_SUCCESS,
    GET_HYBRIS_USER_DETAILS_FAILURE,
    SET_LOGOUT,
    SET_LOGOUT_SUCCESS,
    SET_LOGOUT_FAILURE,
    SET_LOGOUT_SSO,
    GET_BANNER_DETAILS,
    GET_BANNER_DETAILS_SUCCESS,
    GET_BANNER_DETAILS_FAILURE,
    GET_BANNER_LENGTH,
    SET_BANNER_FREQUECY,
    SHOW_DISMISSED_BANNER,
    HIDE_DISMISSED_BANNER,
    SET_BANNER_HEIGHT,
    SET_FORBIDDEN_ERROR_CHECK_VALUE,
    SET_CONFIG_TABLE_RULES,
    SET_MAST_ORDER,
    SET_BANNER_DETAILS,
    SET_CONFIRMATION_BANNER,
    SET_DESTRUCTIVE,
    IS_CONDENSED_VIEW,
    IS_HIDE_CONDENSED_VIEW,
    IS_HEADER_CONDENSED_VIEW,
    SET_PEDIATRIC_CHECK,
    GET_HYBRIS_USER_DETAILS_LOADING,
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
} from 'src/common/redux/actions/constants';
import { checkImpersonationActive, checkProxyActive } from 'src/utils/util';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
    DISABLED,
    ENABLED,
    MANDATORY,
    MENU,
    NOT_VISIBLE,
    US_COUNTRY_CODE,
    VISIBLE,
    SCHEDULE_SURGERY,
    MAST,
    NOT_MANDATORY,
    INVENTORY,
    CONSIGNMENT_BILLING,
    REPLENISHMENT,
    CONSIGNMENT_REPLENISHMENT,
    REPORT_USAGE,
    EQUITY,
    SETTINGS,
    ORDERS,
    REPORT_USAGE_SURGERY,
    REPORT_USAGE_MAST,
    CONSIGNMENT_RETURN,
    CONSIGNMENT_ADD,
    REPORT_PROCEDURE_DATA,
    TEMPLATES,
    NO_USAGE_REPORT,
    PROXY,
} from 'src/constants/appConstants';
import {
    GET_CONFIGURATION,
    GET_CONFIGURATION_FAILURE,
    GET_CONFIGURATION_SUCCESS,
    RESET_BANNERS,
} from '../actions/constants';
import equity from 'src/pages/equity/redux/reducers/equity';
const defaultValue = { metadata: ['Procedure_data'] };
const initialState = {
    userDetails: {},
    hybrisUserDetails: {},
    isAuthenticatedWithHybris: false,
    error: '',
    loading: false,
    loginLoading: false,
    loginError: '',
    userDetailsLoading: false,
    isLanguageChanged: false,
    loggingOut: false,
    loggingOutSSO: false,
    logoutStatusCode: '',
    bannerInfo: [],
    bannerLength: 0,
    bannerFrequency: 300,
    showDismissedBanner: false,
    bannerHeight: '',
    isForbidden: false,
    surgeryVisualInspection: NOT_VISIBLE,
    surgeryDeliveryDateVisibilityRule: 'NOT_VISIBLE',
    surgeryDeliveryDateLeadTime: NOT_VISIBLE,
    shipDontShipSurgery: NOT_VISIBLE,
    createOrderDetails: {
        scheduleSurgery: false,
        mastSurgery: false,
        equity: false,
        consignmentBilling: false,
        inventory: false,
        consignmentReturn: false,
        consignmentReturnInventory: false,
        consignmentAdd: false,
    },
    orderTypeVisibilityConfig: {
        ALL_ORDERS_Visibility: NOT_VISIBLE,
        ZLB_OrderTypeVisibility: NOT_VISIBLE,
        ZLC_OrderTypeVisibility: NOT_VISIBLE,
        MAST_OrderTypeVisibility: NOT_VISIBLE,
        ZOR_OrderTypeVisibility: NOT_VISIBLE,
        ZKA_L2_KR_G2_ZRE_OrderTypeVisibility: NOT_VISIBLE,
        KB_KE_OrderTypeVisibility: NOT_VISIBLE,
        Draft_ORDERS_Visibility: NOT_VISIBLE,
    },
    settingFieldVisibilityConfig: {
        calendarSettingVisibility: NOT_VISIBLE,
        unidPlanUpdatesVisibility: NOT_VISIBLE,
        notificationSettingVisibility: NOT_VISIBLE,
    },
    calendarPage: NOT_VISIBLE,
    awaitingPoVisibility: NOT_VISIBLE,
    poSurgeryVisibility: ENABLED,
    poSurgeryMandatory: false,
    patientInformationVisibility: NOT_VISIBLE,
    patientIdVisibility: NOT_VISIBLE,
    patientIdMandatory: false,
    moreVisibility: {
        accounts: false,
        alerts: false,
        announcements: false,
        dashboard: false,
        reactDashboard: true,
        links: false,
        orderHistory: true,
        physicians: false,
        proxies: false,
        settings: false,
        templates: false,
        legacyMobile: false,
    },
    physicianDropdownSurgeryVisibility: NOT_VISIBLE,
    physicianDropdownSurgeryMandatory: false,
    physicianTextSurgeryVisibility: NOT_VISIBLE,
    physicianTextSurgeryMandatory: false,
    physicianTextConsignmentAddVisibility: NOT_VISIBLE,
    physicianTextConsignmentAddMandatory: true,
    physicianTextConsignmentBillingVisibility: ENABLED,
    physicianTextConsignmentBillingMandatory: true,
    //ZG-Partner
    //Surgery
    physicianDropdownZGSurgeryVisibility: NOT_VISIBLE,
    physicianDropdownZGSurgeryMandatory: '',
    //MAST
    physicianDropdownZGMASTVisibility: ENABLED,
    physicianDropdownZGMASTMandatory: '',
    //ConsignmentAdd
    physicianDropdownZGConsignmentAddVisibility: NOT_VISIBLE,
    physicianDropdownZGConsignmentAddMandatory: '',
    // consignmentBilling
    physicianDropdownZGConsignmentBillingVisibility: '',
    physicianDropdownZGConsignmentBillingMandatory: '',
    // ReportUsage
    physicianDropdownZGReportUsageVisibility: NOT_VISIBLE,
    physicianDropdownZGReportUsageMandatory: NOT_MANDATORY,
    // equity
    physicianDropdownZGEquityVisibility: ENABLED,
    physicianDropdownZGEquityMandatory: '',
    // ReportUsageReplenishment
    physicianDropdownZGReportUsageReplenishmentVisibility: NOT_VISIBLE,
    physicianDropdownZGReportUsageReplenishmentMandatory: NOT_MANDATORY,
    // ConsignmentAddReplenishment
    physicianDropdownZGConsignmentBillingReplenishmentVisibility: '',
    physicianDropdownZGConsignmentBillingReplenishmentMandatory: '',
    //More Physician
    physicianDropdownZGMorePhysicianVisibility: ENABLED,
    physicianDropdownZGMorePhysicianMandatory: true,
    //UnKnownPhysician
    unknownPhysicianVisibility: NOT_VISIBLE,
    unknownPhysicianMandatory: '',
    //settingsAlternateEmailVisibility
    settingsAlternateEmailVisibility: NOT_VISIBLE,
    //deliveryCheckEnabled
    deliveryCheckEdit: '',
    deliveryCheckNoUsageToReport: '',

    inventoryVisibility: {
        receiveSets: false,
        items: false,
        returnSets: false,
        sets: false,
        consigned: false,
    },
    afterHourMessageVisibility: DISABLED,
    afterHourMessageStartTime: '',
    afterHourMessageEndTime: '',
    emeaSurgeryPopup: NOT_VISIBLE,
    salesOrg: '',
    allSalesOrg: [],
    removeExtraItem: {},
    mainMenuVisibility: {
        alerts: false,
        deniedUsageOverrides: false,
        admin: false,
        calendar: false,
        orders: false,
        productGuide: false,
        more: false,
        inventory: false,
    },
    currentDateDelivery: NOT_VISIBLE,
    additionalProcedure: defaultValue,
    additionalProcedureEquity: defaultValue,
    biologicsDetailEquity: defaultValue,
    deformityCorrectionEquity: defaultValue,
    physicianFinderEligibilityEquity: defaultValue,
    procedureDataPhysicianEquity: NOT_VISIBLE,
    biologicsUsedEquity: defaultValue,
    retractorUsedEquity: defaultValue,
    advancedEnergyEquity: defaultValue,
    infoBanner: [],
    confirmationBanner: [],
    isDestructiveEnabled: false,
    biologicsDetail: defaultValue,
    deformityCorrection: defaultValue,
    physicianFinderEligibility: defaultValue,
    procedureDataPhysician: NOT_VISIBLE,
    biologicsUsed: defaultValue,
    retractorUsed: defaultValue,
    advancedEnergy: defaultValue,
    reportUsagePatientDetails: [''], //visibility of patient details in usage
    reportUsagePatientDetailsMandatory: [''], //mandatory of patient details in usage
    patient_Details: [''], //visibility of patient details in billing
    patient_DetailsMandatory: [''], //mandatory of patient details in billing
    surgeryPatientDetailsVisibility: [''], //visibility of patient details in surgery
    surgeryPatientDetailsMandatory: [''], //mandatory of patient details in surgery
    procedureTypeConsignmentAdd: 'NOT_VISIBLE',
    procedureTypeConsignmentAddMandatory: 'NO',
    isMastOrder: false,
    requestedDeliveryDateVisibility: 'NOT_VISIBLE',
    requestedDeliveryDateMandatory: 'NO',
    requestedDeliveryDateVisibilityKB: 'VISIBLE',
    requestedDeliveryDateMandatoryKB: 'YES',
    procedurePageVisibility: false,
    procedureEquityPageVisibility: true,
    surgeryNumberVisibility: NOT_VISIBLE,
    consignmentReportVisibility: NOT_VISIBLE,
    surgeryNumberMASTVisibility: 'DISABLED',
    surgeryNumberConsignmentAddVisibility: 'DISABLED',
    surgeryNumberConsignmentBillingVisibility: 'DISABLED',
    surgeryNumberUsageReplenishmentVisibility: 'NOT_VISIBLE',
    surgeryNumberReportUsageVisibility: 'NOT_VISIBLE',
    surgeryNumberMandatory: 'NO',
    consignmentReportMandatory: 'NO',
    surgeryNumberMASTMandatory: 'NO',
    surgeryNumberConsignmentAddMandatory: 'NO',
    surgeryNumberConsignmentBillingMandatory: 'NO',
    surgeryNumberUsageReplenishmentMandatory: 'NO',
    surgeryNumberReportUsageMandatory: 'NO',
    priceOverrideReportUsageVisibility: 'NOT_VISIBLE',
    priceOverrideEquityVisibility: 'VISIBLE',
    priceOverrideConsignmentBillingVisibility: 'VISIBLE',
    billToShipToPartnerRole: '',
    // billToEquityVisibility: 'NOT_VISIBLE',
    // billToEquityMandatory: 'NO',
    billToConsignmentBillingVisibility: 'NOT_VISIBLE',
    billToConsignmentBillingMandatory: 'NO',
    billToConsignmentAddVisibility: 'NOT_VISIBLE',
    billToConsignmentAddMandatory: 'NO',
    billToScheduleSurgeryVisibility: 'NOT_VISIBLE',
    billToScheduleSurgeryMandatory: 'NO',
    billToReportUsageVisibility: 'NOT_VISIBLE',
    billToReportUsageMandatory: 'NO',
    billToConsignmentReturnVisibility: 'NOT_VISIBLE',
    billToConsignmentReturnMandatory: 'NO',
    levelsUsed: NOT_VISIBLE,
    levelsUsedEquity: NOT_VISIBLE,
    billToVisibility: 'NOT_VISIBLE',
    billToMandatory: NOT_MANDATORY,
    requestedDeliveryDateVisible: NOT_VISIBLE,
    //SIM-949
    requestedDeliveryDateVisibilityKE: 'NOT_VISIBLE',
    requestedDeliveryDateMandatoryKE: 'NO',
    reportPaymentButtonVisibility: 'NOT_VISIBLE',
    consignmentBillingPaymentVisibility: ENABLED,
    attnFieldVisibility: NOT_VISIBLE,
    transferRecipientVisibility: NOT_VISIBLE,
    careOfFieldVisibility: NOT_VISIBLE,
    careOfFieldMandatory: NOT_MANDATORY,
    shipToFieldVisibility: NOT_VISIBLE,
    careOfFieldVisibilityZLC: 'NOT_VISIBLE',
    careOfFieldVisibilityKB: 'NOT_VISIBLE',
    careOfFieldVisibilityKE: 'NOT_VISIBLE',
    careOfFieldVisibilityZLCR: 'NOT_VISIBLE',
    isShowBomChanges: false,
    specialStockPartnerVisibilityKB: 'NOT_VISIBLE',
    specialStockPartnerMandatoryKB: 'NO',
    purchaseOrderVisibilityKB: 'NOT_VISIBLE',
    shortTermConsignmentVisibilityKB: 'NOT_VISIBLE',
    longTermConsignmentVisibilityKB: 'NOT_VISIBLE',
    shortTermConsignmentMandatoryKB: 'NO',
    longTermConsignmentMandatoryKB: 'NO',
    implantDateVisibility: 'NOT_VISIBLE',
    implantDateMandatory: 'NO',
    specialStockPartnerVisibilityKE: 'NOT_VISIBLE',
    specialStockPartnerMandatoryKE: 'NO',
    shortTermConsignmentVisibilityKE: 'NOT_VISIBLE',
    longTermConsignmentVisibilityKE: 'NOT_VISIBLE',
    shortTermConsignmentMandatoryKE: 'NO',
    longTermConsignmentMandatoryKE: 'NO',
    procedureVisibilityKE: 'NOT_VISIBLE',
    procedureMandatoryKE: 'NO',
    isCondensedView: '',
    requestedDeliveryDateCutOffTime: 'DISABLED',
    productTypeVisibility: NOT_VISIBLE,
    productTypeMandatory: NOT_MANDATORY,
    isHeaderCondensedView: 'DISABLED',
    hideCondensedViewToggle: false,
    allDayRequestedDeliveryDate: 'DISABLED',
    enableRequestedDeliveryDateForWeekEnd: NOT_VISIBLE,
    usageReplenishmentSurgeryDateVisibility: NOT_VISIBLE,
    usageReplenishmentSurgeryDateMandatoryRule: 'NO',
    requestedDeliveryDateMandatoryZLC: NOT_MANDATORY,
    procedureVisibility: NOT_VISIBLE,
    procedureMandatory: NOT_MANDATORY,
    specialStockPartnerVisibility: NOT_VISIBLE,
    specialStockPartnerMandatory: NOT_MANDATORY,
    shortTermConsignmentVisibility: NOT_VISIBLE,
    longTermConsignmentVisibility: NOT_VISIBLE,
    shortTermConsignmentMandatory: NOT_MANDATORY,
    longTermConsignmentMandatory: NOT_MANDATORY,
    surgeryNumberReplenishmentVisibility: NOT_VISIBLE,
    surgeryNumberReplenishmentMandatory: NOT_MANDATORY,
    physicianTextVisibility: NOT_VISIBLE,
    patientDetailsVisibility: [],
    patientDetailsMandatory: [],
    physicianDropdownVisibility: NOT_VISIBLE,
    physicianDropdownyMandatory: NOT_MANDATORY,
    physicianDropdownZGVisibility: NOT_VISIBLE,
    physicianDropdownZGMandatory: NOT_MANDATORY,
    physicianDropdownZGReplenishmentVisibility: NOT_VISIBLE,
    physicianDropdownZGReplenishmentMandatory: NOT_MANDATORY,
    configRule: [],
    procedureTypeUsageVisibility: NOT_VISIBLE,
    procedureTypeEquityVisibility: NOT_VISIBLE,
    procedureTypeUsageMandatoryRule: NOT_MANDATORY,
    procedureTypeEquityMandatoryRule: NOT_MANDATORY,
    pediatricCheck: '',
    accountPhysicianAPIUsage: false,
    accountPhysicianAPIReplenishment: false,
    pediatricSurgeryMandatory: NOT_MANDATORY,
    pediatricSurgery: NOT_VISIBLE,
    signatureVisibilityUsage: NOT_VISIBLE,
    priceOverrideReasonVisibilityUsage: NOT_VISIBLE,
    priceOverrideReasonMandatoryUsage: NOT_MANDATORY,
    priceOverrideCommentsVisibilityUsage: NOT_VISIBLE,
    priceOverrideCommentsMandatoryUsage: NOT_MANDATORY,
    replenishmentPageVisibilityUsage: false,
    priceOverrideVisibility: NOT_VISIBLE,
    competitorChosenVisibility: NOT_VISIBLE,
    usageViaEquityOrderVisibility: NOT_VISIBLE,
    instrumentOnlySurgeryVisibility: NOT_VISIBLE,
    calendarSettingMetadata: [],
    unidPlanUpdatesMetadata: [],
    notificationSettingMetadata: [],
    contactNameVisibility: NOT_VISIBLE,
    contactNameMandatory: NOT_MANDATORY,
    contactNumberVisibility: NOT_VISIBLE,
    contactNumberMandatory: NOT_MANDATORY,
    createTemplateVisibility: NOT_VISIBLE,
    notesVisibility: NOT_VISIBLE,
    addProductVisibility: NOT_VISIBLE,
    templateDropdownVisibility: NOT_VISIBLE,
    priceOverrideCommentsMandatory: NOT_MANDATORY,
    priceOverrideCommentsVisibility: NOT_VISIBLE,
    priceOverrideReasonMandatory: NOT_MANDATORY,
    priceOverrideReasonVisibility: NOT_VISIBLE,
    surgeryTemplateVisibility: NOT_VISIBLE,
    mastTemplateVisibility: NOT_VISIBLE,
    equityTemplateVisibility: NOT_VISIBLE,
    templateNotesVisibility: NOT_VISIBLE,
    templateProcedureVisibility: NOT_VISIBLE,
    templateProcedureMandatory: NOT_MANDATORY,
    addProductTemplateVisibility: [],
    proxyRadioButton: NOT_VISIBLE,
    proxyAutopopulateContactName: NOT_VISIBLE,
    transferRecipientMeta: [],
    transferRecipientMandatory: NOT_MANDATORY,
    notificationFailureFilterVisibility: NOT_VISIBLE,
    //SIM-1893
    reportUsageStealthAutoPilotVisibility: NOT_VISIBLE,
    reportUsageStealthLiveAlignVisibility: NOT_VISIBLE,
    equityStealthAutoPilotVisibility: NOT_VISIBLE,
    equityStealthLiveAlignVisibility: NOT_VISIBLE,
    physicianTextUsageMandatory:NOT_MANDATORY,
    physicianTextUsageVisibility: NOT_VISIBLE,
};
// Helper function to safely escape regex special characters to prevent ReDoS attacks
const escapeRegExp = (str) => {
    if (typeof str !== 'string') return '';
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};

// Builds a case-insensitive regex pattern that matches any of the given values exactly
const buildExactMatchPattern = (values) => {
    const escaped = values.map((val) => escapeRegExp(val));
    return new RegExp(`^(${escaped.join('|')})$`, 'i');
};

//for controlling procedure page data in reportUsage order for japan, ENABLED condtion is commented ,If required uncomment in this below function
const filterObject = (object, field, isFromEquity, module) => {
    const targetModule = module
        ? module
        : isFromEquity
        ? 'EQUITY'
        : 'REPORT_USAGE';
    let patientDetails = ['href', 'name', 'sex', 'dob'];
    if (field === 'reportUsagePatientDetails') {
        let array;
        const result = object?.find((data) => {
            return (
                data.feature === 'PATIENT_DETAILS' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === 'VISIBLE' &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            const trimData = result?.metadata
                .split(',')
                ?.map((item) => item.trim());
            const pattern = buildExactMatchPattern(trimData);
            if (trimData[0] !== 'PATIENT_DETAILS') {
                if (result.ruleValue === 'VISIBLE') {
                    array = patientDetails
                        .filter((item) => pattern.test(item))
                        .map((item, index) => {
                            let obj = item;
                            return obj;
                        });
                }
            } else {
                return array;
            }
        } else {
            array = [];
        }
        return array;
    } else if (field === 'reportUsagePatientDetailsMandatory') {
        let array;
        const result = object?.find((data) => {
            return (
                data.feature === 'PATIENT_DETAILS' &&
                data.module === targetModule &&
                data.ruleName === 'MANDATORY' &&
                data.ruleValue === 'YES' &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            const trimData = result?.metadata
                .split(',')
                ?.map((item) => item.trim());
            const pattern = buildExactMatchPattern(trimData);
            if (trimData[0] !== 'PATIENT_DETAILS') {
                if (result.ruleValue === 'YES') {
                    array = patientDetails
                        .filter((item) => pattern.test(item))
                        .map((item) => {
                            let obj = item;
                            return obj;
                        });
                } else if (result.ruleValue === 'NO') {
                    array = patientDetails
                        .filter((item) => !pattern.test(item))
                        .map((item) => {
                            let obj = item;
                            return obj;
                        });
                }
            } else {
                return [];
            }
        } else {
            array = [];
        }
        return array;
    } else if (field === 'additionalProcedure') {
        const result = object?.find((data) => {
            return (
                data.feature === 'ADDITIONAL_PROCEDURE_DATA' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === VISIBLE &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            return {
                metadata: result.metadata.split(','),
                ruleValue: result.ruleValue,
            };
        } else {
            const ruleValue =
                object?.find(
                    (data) =>
                        data.feature === 'ADDITIONAL_PROCEDURE_DATA' &&
                        data.module === targetModule &&
                        data.ruleName === 'VISIBILITY'
                )?.ruleValue || NOT_VISIBLE;
            if (ruleValue === VISIBLE) {
                return { metadata: ['Procedure_data'] };
            } else {
                return {
                    metadata: ['ADDITIONAL_PROCEDURE_DATA'],
                    ruleValue: NOT_VISIBLE,
                };
            }
        }
    } else if (field === 'advancedEnergy') {
        const result = object?.find((data) => {
            return (
                data.feature === 'ADVANCED_ENERGY' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === VISIBLE &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            return {
                metadata: result.metadata.split(','),
                ruleValue: result.ruleValue,
            };
        } else {
            const ruleValue =
                object?.find(
                    (data) =>
                        data.feature === 'ADVANCED_ENERGY' &&
                        data.module === targetModule &&
                        data.ruleName === 'VISIBILITY'
                )?.ruleValue || NOT_VISIBLE;
            if (ruleValue === VISIBLE) {
                return { metadata: ['Procedure_data'] };
            } else {
                return {
                    metadata: ['ADVANCED_ENERGY'],
                    ruleValue: NOT_VISIBLE,
                };
            }
        }
    } else if (field === 'physicianFinderEligibility') {
        const result = object?.find((data) => {
            return (
                data.feature === 'PHYSICIAN_FINDER_ELIGIBILITY' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === VISIBLE &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            return {
                metadata: result.metadata.split(','),
                ruleValue: result.ruleValue,
            };
        } else {
            const ruleValue =
                object?.find(
                    (data) =>
                        data.feature === 'PHYSICIAN_FINDER_ELIGIBILITY' &&
                        data.module === targetModule &&
                        data.ruleName === 'VISIBILITY'
                )?.ruleValue || NOT_VISIBLE;
            if (ruleValue === VISIBLE) {
                return { metadata: ['Procedure_data'] };
            } else {
                return {
                    metadata: ['PHYSICIAN_FINDER_ELIGIBILITY'],
                    ruleValue: NOT_VISIBLE,
                };
            }
        }
    } else if (field === 'deformityCorrection') {
        const result = object?.find((data) => {
            return (
                data.feature === 'DEFORMITY_CORRECTION' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === VISIBLE &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            return {
                metadata: result.metadata.split(','),
                ruleValue: result.ruleValue,
            };
        } else {
            const ruleValue =
                object?.find(
                    (data) =>
                        data.feature === 'DEFORMITY_CORRECTION' &&
                        data.module === targetModule &&
                        data.ruleName === 'VISIBILITY'
                )?.ruleValue || NOT_VISIBLE;
            if (ruleValue === VISIBLE) {
                return { metadata: ['Procedure_data'] };
            } else {
                return {
                    metadata: ['DEFORMITY_CORRECTION'],
                    ruleValue: NOT_VISIBLE,
                };
            }
        }
    } else if (field === 'biologicsUsed') {
        const result = object?.find((data) => {
            return (
                data.feature === 'BIOLOGICS_USED' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === VISIBLE &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            return {
                metadata: result.metadata.split(','),
                ruleValue: result.ruleValue,
            };
        } else {
            const ruleValue =
                object?.find(
                    (data) =>
                        data.feature === 'BIOLOGICS_USED' &&
                        data.module === targetModule &&
                        data.ruleName === 'VISIBILITY'
                )?.ruleValue || NOT_VISIBLE;
            if (ruleValue === VISIBLE) {
                return { metadata: ['Procedure_data'] };
            } else {
                return { metadata: ['BIOLOGICS_USED'], ruleValue: NOT_VISIBLE };
            }
        }
    } else if (field === 'retractorUsed') {
        const result = object?.find((data) => {
            return (
                data.feature === 'RETRACTOR_USED' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === VISIBLE &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            return {
                metadata: result.metadata.split(','),
                ruleValue: result.ruleValue,
            };
        } else {
            const ruleValue =
                object?.find(
                    (data) =>
                        data.feature === 'RETRACTOR_USED' &&
                        data.module === targetModule &&
                        data.ruleName === 'VISIBILITY'
                )?.ruleValue || NOT_VISIBLE;
            if (ruleValue === VISIBLE) {
                return { metadata: ['Procedure_data'] };
            } else {
                return { metadata: ['RETRACTOR_USED'], ruleValue: NOT_VISIBLE };
            }
        }
    } else if (field === 'biologicsDetail') {
        const result = object?.find((data) => {
            return (
                data.feature === 'BIOLOGICS' &&
                data.module === targetModule &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === VISIBLE &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            return {
                metadata: result.metadata.split(','),
                ruleValue: result.ruleValue,
            };
        } else {
            const ruleValue =
                object?.find(
                    (data) =>
                        data.feature === 'BIOLOGICS' &&
                        data.module === targetModule &&
                        data.ruleName === 'VISIBILITY'
                )?.ruleValue || NOT_VISIBLE;
            if (ruleValue === VISIBLE) {
                return { metadata: ['Procedure_data'] };
            } else {
                return { metadata: ['BIOLOGICS'], ruleValue: NOT_VISIBLE };
            }
        }
    } else if (field === 'patient_Details') {
        let array;
        const result = object?.find((data) => {
            return (
                data.feature === 'PATIENT_DETAILS' &&
                data.module === 'CONSIGNMENT_BILLING' &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === 'NOT_VISIBLE' &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            const trimData = result?.metadata
                .split(',')
                ?.map((item) => item.trim());
            const pattern = buildExactMatchPattern(trimData);
            if (trimData[0] !== 'PATIENT_DETAILS') {
                if (result.ruleValue === 'NOT_VISIBLE') {
                    array = patientDetails
                        .filter((item) => !pattern.test(item))
                        .map((item, index) => {
                            let obj = item;
                            return obj;
                        });
                } else if (result.ruleValue === 'ENABLED') {
                    array = patientDetails
                        .filter((item) => pattern.test(item))
                        .map((item, index) => {
                            let obj = item;
                            return obj;
                        });
                }
            } else {
                return array;
            }
        } else {
            array = patientDetails;
        }
        return array;
    } else if (field === 'patient_DetailsMandatory') {
        let array;
        const result = object?.find((data) => {
            return (
                data.feature === 'PATIENT_DETAILS' &&
                data.module === 'CONSIGNMENT_BILLING' &&
                data.ruleName === 'MANDATORY' &&
                data.ruleValue === 'YES' &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            const trimData = result?.metadata
                .split(',')
                ?.map((item) => item.trim());
            const pattern = buildExactMatchPattern(trimData);
            if (trimData[0] !== 'PATIENT_DETAILS') {
                if (result.ruleValue === 'YES') {
                    array = patientDetails
                        .filter((item) => pattern.test(item))
                        .map((item) => {
                            let obj = item;
                            return obj;
                        });
                } else if (result.ruleValue === 'NO') {
                    array = patientDetails
                        .filter((item) => !pattern.test(item))
                        .map((item) => {
                            let obj = item;
                            return obj;
                        });
                }
            } else {
                return [];
            }
        } else {
            array = [];
        }
        return array;
    } else if (field === 'surgeryPatientDetails') {
        let array;
        const result = object?.find((data) => {
            return (
                data.feature === 'PATIENT_DETAILS' &&
                data.module === 'SCHEDULE_SURGERY' &&
                data.orderType === 'ZLC' &&
                data.ruleName === 'VISIBILITY' &&
                data.ruleValue === 'NOT_VISIBLE' &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            const trimData = result?.metadata
                .split(',')
                ?.map((item) => item.trim());
            const pattern = buildExactMatchPattern(trimData);
            if (trimData[0] !== 'PATIENT_DETAILS') {
                if (result.ruleValue === 'NOT_VISIBLE') {
                    array = patientDetails
                        .filter((item) => !pattern.test(item))
                        .map((item, index) => {
                            let obj = item;
                            return obj;
                        });
                } else if (result.ruleValue === 'ENABLED') {
                    array = patientDetails
                        .filter((item) => pattern.test(item))
                        .map((item, index) => {
                            let obj = item;
                            return obj;
                        });
                }
            } else {
                return array;
            }
        } else {
            array = patientDetails;
        }
        return array;
    } else if (field === 'surgeryPatientDetailsMandatory') {
        let array;
        const result = object?.find((data) => {
            return (
                data.feature === 'PATIENT_DETAILS' &&
                data.module === 'SCHEDULE_SURGERY' &&
                data.ruleName === 'MANDATORY' &&
                data.ruleValue === 'YES' &&
                data?.metadata !== '' &&
                data?.metadata !== undefined &&
                data?.metadata !== null
            );
        });
        if (result !== undefined && result !== '') {
            const trimData = result?.metadata
                .split(',')
                ?.map((item) => item.trim());
            const pattern = buildExactMatchPattern(trimData);
            if (trimData[0] !== 'PATIENT_DETAILS') {
                if (result.ruleValue === 'YES') {
                    array = patientDetails
                        .filter((item) => pattern.test(item))
                        .map((item) => {
                            let obj = item;
                            return obj;
                        });
                } else if (result.ruleValue === 'NO') {
                    array = patientDetails
                        .filter((item) => !pattern.test(item))
                        .map((item) => {
                            let obj = item;
                            return obj;
                        });
                }
            } else {
                return [];
            }
        } else {
            array = [];
        }
        return array;
    }
};
// This function is used to get the create option for modules to be visible based on the Config data
export const getCreateOrderDetails = (emeaData) => {
    let orderListData = {
        ...initialState.createOrderDetails,
    };

    emeaData
        .filter(
            (data) =>
                data.feature === 'CREATE' &&
                data.ruleName === 'VISIBILITY' &&
                data.module === 'ORDERS'
        )
        ?.map((data) => {
            if (data.orderType === 'ZLC' && data.metadata === 'MAST') {
                orderListData.mastSurgery = data.ruleValue === VISIBLE;
            } else if (data.orderType === 'ZLC') {
                orderListData.scheduleSurgery = data.ruleValue === VISIBLE;
            } else if (data.orderType === 'ZOR') {
                orderListData.equity = data.ruleValue === VISIBLE;
            } else if (data.orderType === 'KE') {
                orderListData.consignmentBilling = data.ruleValue === VISIBLE;
                orderListData.inventory = data.ruleValue === VISIBLE;
            } else if (data.orderType === 'ZKA') {
                orderListData.consignmentReturn = data.ruleValue === VISIBLE;
                orderListData.consignmentReturnInventory =
                    data.ruleValue === VISIBLE;
            } else if (data.orderType === 'KB') {
                orderListData.consignmentAdd = data.ruleValue === VISIBLE;
            }
        });
    return orderListData;
};
// This function is used to get the visibility of the modules in the more menu based on the Config data
export const getMoreModuleVisibility = (emeaData) => {
    let moreVisibility = {
        ...initialState.moreVisibility,
    };

    emeaData
        .filter(
            (data) => data.module === 'MORE' && data.ruleName === 'VISIBILITY'
        )
        ?.map((data) => {
            if (data.feature === 'ACCOUNTS') {
                moreVisibility.accounts = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'ALERTS') {
                moreVisibility.alerts = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'ANNOUNCEMENT') {
                moreVisibility.announcements = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'DASHBOARD') {
                moreVisibility.dashboard = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'REACT_DASHBOARD') {
                moreVisibility.reactDashboard = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'LINKS') {
                moreVisibility.links = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'ORDER_HISTORY') {
                moreVisibility.orderHistory = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'PHYSICIANS') {
                moreVisibility.physicians = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'PROXIES') {
                moreVisibility.proxies = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'SETTINGS') {
                moreVisibility.settings = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'TEMPLATES') {
                moreVisibility.templates = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'LEGACY_MOBILE') {
                moreVisibility.legacyMobile = data.ruleValue !== NOT_VISIBLE;
            }
        });
    return moreVisibility;
};
//This function is used to get the visibility of the main menu based on the Config data
export const getMainMenuVisibility = (emeaData) => {
    let mainMenuVisibility = {
        ...initialState.mainMenuVisibility,
    };

    emeaData
        .filter(
            (data) =>
                data.module === 'MAIN_MENU' && data.ruleName === 'VISIBILITY'
        )
        ?.map((data) => {
            if (data.feature === 'ALERTS') {
                mainMenuVisibility.alerts = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'DENIED_USAGE_OVERRIDE') {
                mainMenuVisibility.deniedUsageOverrides =
                    data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'ADMIN') {
                mainMenuVisibility.admin = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'ORDERS') {
                mainMenuVisibility.orders = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'CALENDAR') {
                mainMenuVisibility.calendar = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'PRODUCT_GUIDE') {
                mainMenuVisibility.productGuide =
                    data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'MORE') {
                mainMenuVisibility.more = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'INVENTORY') {
                mainMenuVisibility.inventory = data.ruleValue !== NOT_VISIBLE;
            }
        });
    return mainMenuVisibility;
};
//This function is used to get the visibility of the tabs in inventory module based on the Config data
export const getInventoryVisibility = (emeaData) => {
    let inventoryVisibility = {
        ...initialState.inventoryVisibility,
    };

    emeaData
        .filter(
            (data) =>
                data.module === 'INVENTORY' && data.ruleName === 'VISIBILITY'
        )
        ?.map((data) => {
            if (data.feature === 'RECEIVE_SETS') {
                inventoryVisibility.receiveSets =
                    data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'ITEMS') {
                inventoryVisibility.items = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'RETURN_SETS') {
                inventoryVisibility.returnSets = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'SETS') {
                inventoryVisibility.sets = data.ruleValue !== NOT_VISIBLE;
            } else if (data.feature === 'CONSIGNED') {
                inventoryVisibility.consigned = data.ruleValue !== NOT_VISIBLE;
            }
        });
    return inventoryVisibility;
};

export const getUsageConfigRules = (configRulesDataList, option) => {
    return {
        physicianDropdownZGReportUsageVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB'
            )[0]?.ruleValue || NOT_VISIBLE,
        physicianDropdownZGReportUsageMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === option &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZLB'
            )[0]?.ruleValue || NOT_MANDATORY,
        accountPhysicianAPIUsage:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB' &&
                    data.metadata === 'accountPhysician'
            )[0]?.ruleValue === VISIBLE
                ? true
                : false,
        procedureDataPhysician:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue || NOT_VISIBLE,
        procedureTypeUsageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.module === 'REPORT_USAGE' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || NOT_VISIBLE,
        procedureTypeUsageMandatoryRule:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.module === 'REPORT_USAGE' &&
                    data.ruleName === 'MANDATORY'
            )?.ruleValue || NOT_MANDATORY,
        procedurePageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_PAGE' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue === VISIBLE
                ? true
                : false,
        priceOverrideReportUsageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue || NOT_VISIBLE,
        reportPaymentButtonVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'REPORT_PAYMENT' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY'
            )[0]?.ruleValue || NOT_VISIBLE,
        reportUsagePatientDetails: filterObject(
            configRulesDataList,
            'reportUsagePatientDetails'
        ),
        reportUsagePatientDetailsMandatory: filterObject(
            configRulesDataList,
            'reportUsagePatientDetailsMandatory'
        ),
        physicianDropdownZGReportUsageReplenishmentVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLCR'
            )[0]?.ruleValue || NOT_VISIBLE,
        accountPhysicianAPIReplenishment:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLCR' &&
                    data.metadata === 'accountPhysician'
            )[0]?.ruleValue === VISIBLE
                ? true
                : false,
        physicianDropdownZGReportUsageReplenishmentMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZLCR'
            )[0]?.ruleValue || NOT_MANDATORY,

        surgeryNumberUsageReplenishmentVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_VISIBLE,
        surgeryNumberUsageReplenishmentMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_MANDATORY,
        surgeryNumberReportUsageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue || NOT_VISIBLE,
        surgeryNumberReportUsageMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.module === option &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue || NOT_MANDATORY,
        requestedDeliveryDateMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_MANDATORY,
        requestedDeliveryDateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || 'NOT_VISIBLE',
        careOfFieldVisibilityZLCR:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'CARE_OF_FIELD' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR' &&
                    data.ruleName === 'VISIBILITY'
            )[0]?.ruleValue || 'NOT_VISIBLE',
        careOfFieldMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CARE_OF_FIELD' &&
                    data.module === 'REPLENISHMENT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_MANDATORY,
        usageReplenishmentSurgeryDateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_DATE' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || NOT_VISIBLE,
        usageReplenishmentSurgeryDateMandatoryRule:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_DATE' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR' &&
                    data.ruleName === 'MANDATORY'
            )?.ruleValue || 'NO',
        billToReportUsageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || 'NOT_VISIBLE',

        billToReportUsageMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR' &&
                    data.ruleName === 'MANDATORY'
            )?.ruleValue || 'NO',
        billToShipToPartnerRole:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHIP_TO_PARTNER_ROLE' &&
                    data.ruleName === 'PARTNER_ASSIGNMENT' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || '',
        attnFieldVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'ATTN_FIELD' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_VISIBLE,
        patientInformationVisibility: configRulesDataList
            ?.find(
                (data) =>
                    data.feature === 'PATIENT_DETAILS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === 'ZLB' &&
                    data.ruleValue === VISIBLE
            )
            ?.metadata?.split(',')
            .some((item) => item !== 'href')
            ? VISIBLE
            : NOT_VISIBLE,
        patientIdVisibility: configRulesDataList
            ?.find(
                (data) =>
                    data.feature === 'PATIENT_DETAILS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === 'ZLB' &&
                    data.ruleValue === VISIBLE
            )
            ?.metadata?.split(',')
            .some((item) => item === 'href')
            ? VISIBLE
            : NOT_VISIBLE,
        patientIdMandatory:
            configRulesDataList
                ?.filter(
                    (data) =>
                        data.feature === 'PATIENT_DETAILS' &&
                        data.module === option &&
                        data.ruleName === 'MANDATORY' &&
                        data.ruleValue === 'YES' &&
                        data?.metadata !== '' &&
                        data?.metadata !== undefined &&
                        data?.metadata !== null
                )
                ?.metadata?.split(',')
                .some((item) => item === 'href') === MANDATORY
                ? true
                : false,
        levelsUsed:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'LEVELS' &&
                    data.module === 'REPORT_USAGE' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || NOT_VISIBLE,
        allDayRequestedDeliveryDate:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'RDD_ALLDAY' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || 'DISABLED',
        requestedDeliveryDateCutOffTime:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'RDD_CUTOFFTIME' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.metadata || 'DISABLED',
        currentDateDelivery:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'RDD_CURRENT_DATE' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue ?? NOT_VISIBLE,
        enableRequestedDeliveryDateForWeekEnd:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'RDD_WEEKEND' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_VISIBLE,
        biologicsUsed: filterObject(configRulesDataList, 'biologicsUsed'),
        deformityCorrection: filterObject(
            configRulesDataList,
            'deformityCorrection'
        ),
        retractorUsed: filterObject(configRulesDataList, 'retractorUsed'),
        additionalProcedure: filterObject(
            configRulesDataList,
            'additionalProcedure'
        ),
        biologicsDetail: filterObject(configRulesDataList, 'biologicsDetail'),
        physicianFinderEligibility: filterObject(
            configRulesDataList,
            'physicianFinderEligibility'
        ),
        advancedEnergy: filterObject(configRulesDataList, 'advancedEnergy'),
        pediatricSurgery:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PEDIATRIC_SURGERY' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_VISIBLE,
        pediatricSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PEDIATRIC_SURGERY' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_MANDATORY,
        signatureVisibilityUsage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SIGNATURE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_VISIBLE,
        priceOverrideReasonVisibilityUsage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_REASON' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_VISIBLE,
        priceOverrideReasonMandatoryUsage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_REASON' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_MANDATORY,
        priceOverrideCommentsVisibilityUsage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_COMMENTS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_VISIBLE,
        priceOverrideCommentsMandatoryUsage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_COMMENTS' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_MANDATORY,
        replenishmentPageVisibilityUsage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'REPLENISHMENT_PAGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === 'ZLB'
            )?.ruleValue === VISIBLE
                ? true
                : false,
        transferRecipientVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'TRANSFER_RECIPIENT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_VISIBLE,
        transferRecipientMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'TRANSFER_RECIPIENT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR'
            )?.ruleValue || NOT_MANDATORY,
        transferRecipientMeta:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'TRANSFER_RECIPIENT' &&
                        data.ruleName === 'VISIBILITY' &&
                        data.module === 'REPLENISHMENT' &&
                        data.orderType === 'ZLCR'
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        notesVisibility:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'NOTES' &&
                        data.ruleName === 'VISIBILITY' &&
                        data.ruleValue === VISIBLE &&
                        data.module === option &&
                        data.orderType === 'ZLB'
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        reportUsageStealthAutoPilotVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'STEALTH_AUTO_PILOT' &&
                    data.module === 'REPORT_USAGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue || NOT_VISIBLE,
        reportUsageStealthLiveAlignVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'STEALTH_LIVEALIGN' &&
                    data.module === 'REPORT_USAGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue || NOT_VISIBLE,
                physicianTextUsageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_VISIBLE,
        physicianTextUsageMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.module === option &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZLB'
            )?.ruleValue ?? NOT_MANDATORY,
    };
};

export const getOrderFlowConfigRules = (
    configRulesDataList,
    option,
    ordertype = null
) => {
    const findOrderType = (option) => {
        let orderType;
        switch (option === ORDERS ? ordertype : option) {
            case REPORT_USAGE_SURGERY:
                orderType = 'ZLB';
                break;
            case REPORT_USAGE_MAST:
                orderType = 'ZLB';
                break;
            case SCHEDULE_SURGERY:
                orderType = 'ZLC';
                break;
            case MAST:
                orderType = 'ZLC';
                break;
            case CONSIGNMENT_BILLING:
                orderType = 'KE';
                break;
            case EQUITY:
                orderType = 'ZOR';
                break;
            case REPORT_USAGE:
                orderType = 'ZLB';
                break;
            case CONSIGNMENT_RETURN:
                orderType = 'ZKA';
                break;
            case CONSIGNMENT_ADD:
                orderType = 'KB';
                break;
            default:
                orderType = 'undefined';
                break;
        }
        return orderType;
    };
    const orderType = findOrderType(option);
    const OtherModuleFn = () => {
        if (option === CONSIGNMENT_BILLING) return CONSIGNMENT_REPLENISHMENT;
        if (option === REPORT_USAGE) return REPLENISHMENT;
        return '';
    };

    const OtherOrderTypeFn = () => {
        if (orderType === 'KE') return 'KB';
        if (orderType === 'ZLCR') return 'ZLB';
        return '';
    };
    let OtherModule = OtherModuleFn();
    let OtherOrderType = OtherOrderTypeFn();
    let module;
    let type;
    if (option === ORDERS) {
        if (
            ordertype === REPORT_USAGE_SURGERY ||
            ordertype === REPORT_USAGE_MAST
        ) {
            option = ordertype === REPORT_USAGE_MAST ? MAST : SCHEDULE_SURGERY;
            OtherModule = REPLENISHMENT;
            module = REPORT_USAGE;
            OtherOrderType = 'ZLC';
            type = 'ZLCR';
        } else {
            option = ordertype;
        }
    }
    return {
        billToVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue || NOT_VISIBLE,

        billToMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        surgeryNumberVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        surgeryNumberMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        consignmentReportVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONSIGNMENT_REPORT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        consignmentReportMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONSIGNMENT_REPORT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        surgeryNumberReplenishmentVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === OtherModule &&
                    data.orderType === OtherOrderType
            )?.ruleValue ?? NOT_VISIBLE,
        surgeryNumberReplenishmentMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_NUMBER' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === OtherModule &&
                    data.orderType === OtherOrderType
            )?.ruleValue ?? NOT_MANDATORY,
        careOfFieldVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CARE_OF_FIELD' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue || NOT_VISIBLE,
        careOfFieldMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CARE_OF_FIELD' &&
                    data.ruleName === 'MANDATORY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_MANDATORY,
        transferRecipientVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'TRANSFER_RECIPIENT' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue || NOT_VISIBLE,
        transferRecipientMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'TRANSFER_RECIPIENT' &&
                    data.ruleName === 'MANDATORY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue || NOT_MANDATORY,
        transferRecipientMeta:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'TRANSFER_RECIPIENT' &&
                        data.ruleName === 'VISIBILITY' &&
                        (data.module === option ||
                            data.module === OtherModule) &&
                        (data.orderType === orderType ||
                            data.orderType === OtherOrderType)
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        // physicianDropdownSurgeryVisibility:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.metadata === 'physician' &&
        //             data.module === option &&
        //             data.orderType === orderType
        //     )?.ruleValue || NOT_VISIBLE,
        // physicianDropdownSurgeryMandatory:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
        //             data.ruleName === 'MANDATORY' &&
        //             data.metadata === 'physician' &&
        //             data.module === option &&
        //             data.orderType === orderType
        //     )?.ruleValue === MANDATORY,
        // physicianDropdownZGSurgeryMandatory:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
        //             data.ruleName === 'MANDATORY' &&
        //             data.metadata === 'accountPhysician' &&
        //             data.module === option &&
        //             data.orderType === orderType
        //     )?.ruleValue ?? NOT_MANDATORY,
        // physicianDropdownZGSurgeryVisibility:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.metadata === 'accountPhysician' &&
        //             data.module === option &&
        //             data.orderType === orderType
        //     )?.ruleValue ?? NOT_VISIBLE,
        replenishmentPageVisibilityUsage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'REPLENISHMENT_PAGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue === VISIBLE
                ? true
                : false,
        physicianDropdownVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        physicianDropdownyMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue === MANDATORY,
        physicianDropdownZGMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'MANDATORY' &&
                    data.metadata === 'accountPhysician' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        physicianDropdownZGVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'accountPhysician' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        physicianDropdownZGReplenishmentMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'MANDATORY' &&
                    data.metadata === 'accountPhysician' &&
                    data.module === OtherModule &&
                    data.orderType === OtherOrderType
            )?.ruleValue ?? NOT_MANDATORY,
        physicianDropdownZGReplenishmentVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'accountPhysician' &&
                    data.module === OtherModule &&
                    data.orderType === OtherOrderType
            )?.ruleValue ?? NOT_VISIBLE,
        //---------
        isShowBomChanges:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BOM_CHANGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue === VISIBLE ?? false,
        afterHourMessageStartTime:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'AFTER_HOUR_MESSAGING' &&
                    data.ruleName === 'HOUR_START_TIME' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.metadata || '',
        afterHourMessageEndTime:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'AFTER_HOUR_MESSAGING' &&
                    data.ruleName === 'HOUR_END_TIME' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.metadata || '',
        afterHourMessageVisibility: configRulesDataList?.find(
            (data) =>
                data.feature === 'AFTER_HOUR_MESSAGING' &&
                data.ruleName === 'VISIBILITY' &&
                data.module === option &&
                data.orderType === orderType
        )?.ruleValue,
        allDayRequestedDeliveryDate: configRulesDataList?.find(
            (data) =>
                data.feature === 'RDD_DATE' &&
                data.ruleName === 'RDD_ALLDAY' &&
                (data.module === option || data.module === OtherModule) &&
                (data.orderType === orderType ||
                    data.orderType === OtherOrderType)
        )?.ruleValue,
        requestedDeliveryDateCutOffTime: configRulesDataList?.find(
            (data) =>
                data.feature === 'RDD_DATE' &&
                data.ruleName === 'RDD_CUTOFFTIME' &&
                (data.module === option || data.module === OtherModule) &&
                (data.orderType === orderType ||
                    data.orderType === OtherOrderType)
        )?.metadata,
        enableRequestedDeliveryDateForWeekEnd: configRulesDataList?.find(
            (data) =>
                data.feature === 'RDD_DATE' &&
                data.ruleName === 'RDD_WEEKEND' &&
                (data.module === option || data.module === OtherModule) &&
                (data.orderType === orderType ||
                    data.orderType === OtherOrderType)
        )?.ruleValue,
        currentDateDelivery:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'RDD_CURRENT_DATE' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        surgeryDeliveryDateLeadTime:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'LEAD_TIME' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.metadata ?? NOT_VISIBLE,
        surgeryDeliveryDateVisibilityRule:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === module) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_VISIBLE,
        requestedDeliveryDateVisible:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_VISIBLE,
        requestedDeliveryDateMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'MANDATORY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_MANDATORY,
        requestedDeliveryDateMandatoryZLC:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        billToShipToPartnerRole:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHIP_TO_PARTNER_ROLE' &&
                    data.ruleName === 'PARTNER_ASSIGNMENT' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue || '',
        surgeryVisualInspection:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'VISUAL_INSPECTION' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        attnFieldVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'ATTN_FIELD' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_VISIBLE,
        shipDontShipSurgery:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHIP_DONTSHIP' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        emeaSurgeryPopup:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'AVAILABILITY_POPUP' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue || NOT_VISIBLE,
        poSurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PURCHASE_ORDER' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === module) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue || NOT_VISIBLE,
        reportUsagePatientDetails: filterObject(
            configRulesDataList,
            'reportUsagePatientDetails',
            false,
            orderType === 'ZLC'
                ? SCHEDULE_SURGERY
                : orderType === 'ZLB'
                ? REPORT_USAGE
                : option
        ),
        patientInformationVisibility: configRulesDataList
            ?.find(
                (data) =>
                    data.feature === 'PATIENT_DETAILS' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === module) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType) &&
                    data.ruleValue === VISIBLE
            )
            ?.metadata?.split(',')
            .some((item) => item !== 'href')
            ? VISIBLE
            : NOT_VISIBLE,
        patientIdVisibility: configRulesDataList
            ?.find(
                (data) =>
                    data.feature === 'PATIENT_DETAILS' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === module) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType) &&
                    data.ruleValue === VISIBLE
            )
            ?.metadata?.split(',')
            .some((item) => item === 'href')
            ? VISIBLE
            : NOT_VISIBLE,
        patientDetailsVisibility:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'PATIENT_DETAILS' &&
                        data.ruleName === 'VISIBILITY' &&
                        data.module === option &&
                        data.orderType === orderType &&
                        data.ruleValue === VISIBLE
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        patientDetailsMandatory: configRulesDataList
            ?.find(
                (data) =>
                    data.feature === 'PATIENT_DETAILS' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType &&
                    data.ruleValue === MANDATORY
            )
            ?.metadata.split(',')
            .map((item) => item.trim()),
        physicianTextSurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === module) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_VISIBLE,
        physicianTextSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue === MANDATORY,
        specialStockPartnerVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SPECIAL_STOCK_PARTNER' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        specialStockPartnerMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SPECIAL_STOCK_PARTNER' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        priceOverrideVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        consignmentBillingPaymentVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PAYMENT_INFORMATION' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        physicianTextVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        productTypeVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRODUCT_TYPE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        productTypeMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRODUCT_TYPE' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        procedureVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        procedureMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        shortTermConsignmentVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHORT_TERM_CONSIGNEMNT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        longTermConsignmentVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'LONG_TERM_CONSIGNEMNT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        shortTermConsignmentMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHORT_TERM_CONSIGNEMNT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        longTermConsignmentMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'LONG_TERM_CONSIGNEMNT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        pediatricSurgery:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PEDIATRIC_SURGERY' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === module) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_VISIBLE,
        pediatricSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PEDIATRIC_SURGERY' &&
                    data.ruleName === 'MANDATORY' &&
                    (data.module === option || data.module === module) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_MANDATORY,
        unknownPhysicianVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'UNKNOWN_PHYSICIAN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        procedureTypeEquityVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || NOT_VISIBLE,
        procedureDataPhysicianEquity:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || NOT_VISIBLE,
        usageReplenishmentSurgeryDateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SURGERY_DATE' &&
                    data.module === OtherModule &&
                    data.orderType === type &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || NOT_VISIBLE,
        procedureEquityPageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_PAGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue === NOT_VISIBLE
                ? false
                : true,
        requestedDeliveryDateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'RDD_DATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    (data.module === option || data.module === OtherModule) &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_VISIBLE,
        purchaseOrderVisibilityKB:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PURCHASE_ORDER' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        implantDateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'IMPLANT_DATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        implantDateMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'IMPLANT_DATE' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        contactNameVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NAME' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        contactNameMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NAME' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        contactNumberVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NUMBER' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        contactNumberMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NUMBER' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        createTemplateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CREATE_TEMPLATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        notesVisibility:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'NOTES' &&
                        data.ruleName === 'VISIBILITY' &&
                        data.ruleValue === VISIBLE &&
                        data.module === option &&
                        data.orderType === orderType
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        addProductVisibility:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'ADD_PRODUCTS' &&
                        data.ruleName === 'VISIBILITY' &&
                        data.ruleValue === VISIBLE &&
                        data.module === option &&
                        data.orderType === orderType
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        templateDropdownVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'TEMPLATES' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,

        // physician Config
        physicianDropdownZGConsignmentAddVisibility: configRulesDataList?.find(
            (data) =>
                data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                data.module === 'CONSIGNMENT_ADD' &&
                data.ruleName === 'VISIBILITY' &&
                data.orderType === 'KB'
        )?.ruleValue,
        physicianDropdownZGConsignmentAddMandatory: configRulesDataList?.find(
            (data) =>
                data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                data.module === 'CONSIGNMENT_ADD' &&
                data.ruleName === 'MANDATORY' &&
                data.orderType === 'KB'
        )?.ruleValue,
        physicianTextConsignmentAddVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.module === 'CONSIGNMENT_ADD' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
        physicianTextConsignmentAddMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.module === 'CONSIGNMENT_ADD' &&
                    data.ruleName === 'MANDATORY'
            )?.ruleValue === MANDATORY,
        physicianDropdownSurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'physician' &&
                    data.module === option &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue || NOT_VISIBLE,
        physicianDropdownSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'MANDATORY' &&
                    data.metadata === 'physician' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue === MANDATORY,
        physicianDropdownZGSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'MANDATORY' &&
                    data.metadata === 'accountPhysician' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        physicianDropdownZGSurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'accountPhysician' &&
                    data.module === option &&
                    (data.orderType === orderType ||
                        data.orderType === OtherOrderType)
            )?.ruleValue ?? NOT_VISIBLE,
        physicianDropdownZGReportUsageVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.module === module &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === orderType
            )[0]?.ruleValue || NOT_VISIBLE,
        priceOverrideReasonVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_REASON' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        priceOverrideReasonMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_REASON' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        priceOverrideCommentsVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_COMMENTS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        priceOverrideCommentsMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PRICE_OVERRIDE_COMMENTS' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
    };
};

export const getReportProcedureDataConfigRules = (configRulesDataList) => {
    const option = EQUITY;
    const orderType = 'ZOR';
    return {
        pediatricSurgery:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PEDIATRIC_SURGERY' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        pediatricSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PEDIATRIC_SURGERY' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        levelsUsedEquity:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'LEVELS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        unknownPhysicianVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'LEVELS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        priceOverrideEquityVisibility: configRulesDataList?.find(
            (data) =>
                data.feature === 'PRICE_OVERRIDE' &&
                data.ruleName === 'VISIBILITY' &&
                data.module === option &&
                data.orderType === orderType
        )?.ruleValue,
        procedureTypeEquityVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue || NOT_VISIBLE,
        procedureDataPhysicianEquity: configRulesDataList?.find(
            (data) =>
                data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                data.ruleName === 'VISIBILITY' &&
                data.module === option &&
                data.orderType === orderType
        )?.ruleValue,
        procedureEquityPageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_PAGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue === NOT_VISIBLE
                ? false
                : true,
        procedureVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        procedureMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_TYPE' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        additionalProcedureEquity: filterObject(
            configRulesDataList,
            'additionalProcedure',
            true
        ),
        deformityCorrectionEquity: filterObject(
            configRulesDataList,
            'deformityCorrection',
            true
        ),
        biologicsUsedEquity: filterObject(
            configRulesDataList,
            'biologicsUsed',
            true
        ),
        advancedEnergyEquity: filterObject(
            configRulesDataList,
            'advancedEnergy',
            true
        ),
        retractorUsedEquity: filterObject(
            configRulesDataList,
            'retractorUsed',
            true
        ),
        biologicsDetailEquity: filterObject(
            configRulesDataList,
            'biologicsDetail',
            true
        ),
        equityStealthAutoPilotVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'STEALTH_AUTO_PILOT' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === orderType
            )?.ruleValue || NOT_VISIBLE,
        equityStealthLiveAlignVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'STEALTH_LIVEALIGN' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === orderType
            )?.ruleValue || NOT_VISIBLE,
    
    };
};

export const getConsignmentReturnConfigRules = (
    configRulesDataList,
    option
) => {
    const orderType = 'ZKA';
    return {
        billToConsignmentReturnVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === orderType
            )?.ruleValue || 'NOT_VISIBLE',

        billToConsignmentReturnMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.module === option &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === orderType
            )?.ruleValue || 'NO',
        contactNameVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NAME' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        contactNameMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NAME' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
        contactNumberVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NUMBER' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_VISIBLE,
        contactNumberMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CONTACT_NUMBER' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === option &&
                    data.orderType === orderType
            )?.ruleValue ?? NOT_MANDATORY,
    };
};

export const getProxyConfig = (configRulesDataList) => {
    return {
        proxyRadioButton:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'OUTSIDE_DISTRICT_PROXY' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === PROXY
            )?.ruleValue || NOT_VISIBLE,
        proxyAutopopulateContactName:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'POPULATE_CONTACT_NAME' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === PROXY
            )?.ruleValue || NOT_VISIBLE,
    };
};

export const getNoUsageToReportConfig = (configRulesDataList) => {
    return {
        caseCancelledVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CASE_CANCELLED' &&
                    data.module === 'NO_USAGE_REPORT' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
        competitorChosenVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'COMPETITOR_CHOOSEN' &&
                    data.module === 'NO_USAGE_REPORT' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
        usageViaEquityOrderVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'EQUITY_ORDER' &&
                    data.module === 'NO_USAGE_REPORT' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
        instrumentOnlySurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'INSTRUMENT_ONLY' &&
                    data.module === 'NO_USAGE_REPORT' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
    };
};

export const getSettingsConfigRules = (configRulesDataList, option) => {
    return {
        settingsAlternateEmailVisibility:
            configRulesDataList?.find((data) => {
                return (
                    data.feature === 'ALTERNATE_EMAIL_ADDRESS' &&
                    data.module === option &&
                    data.ruleName === 'VISIBILITY'
                );
            })?.ruleValue ?? NOT_VISIBLE,
        calendarSettingMetadata:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'CALENDAR_SETTING' &&
                        data.module === option &&
                        data.ruleName === 'VISIBILITY' &&
                        data.ruleValue === 'VISIBLE'
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        unidPlanUpdatesMetadata:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'UNIDPLANUPDATES' &&
                        data.module === option &&
                        data.ruleName === 'VISIBILITY' &&
                        data.ruleValue === 'VISIBLE'
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
        notificationSettingMetadata:
            configRulesDataList
                ?.find(
                    (data) =>
                        data.feature === 'NOTIFICATION_SETTING' &&
                        data.module === option &&
                        data.ruleName === 'VISIBILITY' &&
                        data.ruleValue === 'VISIBLE'
                )
                ?.metadata?.split(',')
                .map((item) => item.trim()) ?? [],
    };
};

export const getTemplatesConfigRules = (configRulesDataList, orderType) => {
    return {
        physicianDropdownSurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZLC' &&
                    data.metadata === 'physician'
            )?.ruleValue || NOT_VISIBLE,
        physicianDropdownSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZLC'
            )?.ruleValue || NOT_MANDATORY,
        physicianDropdownZGSurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_DROPDOWN' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZLC' &&
                    data.metadata === 'accountPhysician'
            )?.ruleValue ?? NOT_VISIBLE,
        physicianTextSurgeryVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZLC'
            )?.ruleValue ?? NOT_VISIBLE,
        physicianTextSurgeryMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZLC'
            )?.ruleValue ?? NOT_MANDATORY,
        isShowBomChanges:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BOM_CHANGE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZLC'
            )?.ruleValue === VISIBLE ?? false,
        removeExtraItem: (() => {
            const allSalesOrgs = ['S002', 'S030'];
            const result = {};
            allSalesOrgs.forEach((org) => {
                result[org] = NOT_VISIBLE;
            });
            configRulesDataList
                ?.filter(
                    (data) =>
                        data.feature === 'BLOCK_EXTRA_ITEMS' &&
                        data.module === 'TEMPLATES' &&
                        data.ruleName === 'VISIBILITY'
                )
                .forEach((item) => {
                    result[item.salesOrg] = item.ruleValue ?? NOT_VISIBLE;
                });
            return result;
        })(),
        surgeryTemplateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CREATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZLC'
            )?.ruleValue ?? NOT_VISIBLE,
        mastTemplateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CREATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' &&
                    data.metadata === 'ZLC_MAST'
            )?.ruleValue ?? NOT_VISIBLE,
        equityTemplateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CREATE' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' &&
                    data.orderType === 'ZOR'
            )?.ruleValue ?? NOT_VISIBLE,
        templateNotesVisibility: configRulesDataList?.find(
            (data) =>
                data.feature === 'TEMPLATE_NOTES' &&
                data.module === 'TEMPLATES' &&
                data.ruleName === 'VISIBILITY'
        )?.ruleValue ?? NOT_VISIBLE,
        addProductTemplateVisibility: configRulesDataList?.find(
            (data) =>
                data.feature === 'ADD_PRODUCTS' &&
                data.module === 'TEMPLATES' &&
                data.ruleName === 'VISIBILITY' &&
                //data.orderType === orderType &&
                data.ruleValue === VISIBLE
        )?.metadata?.split(',').map((item) => item.trim()) ?? [],
        templateProcedureVisibility: configRulesDataList?.find(
            (data) =>
                data.feature === 'PROCEDURE_TYPE' &&
                data.module === 'TEMPLATES' &&
                data.ruleName === 'VISIBILITY'
        )?.ruleValue ?? NOT_VISIBLE,
        templateProcedureMandatory: configRulesDataList?.find(
            (data) =>
                data.feature === 'PROCEDURE_TYPE' &&
                data.module === 'TEMPLATES' &&
                data.ruleName === 'MANDATORY'
        )?.ruleValue ?? NOT_MANDATORY,
        billToVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' 
            )?.ruleValue || NOT_VISIBLE,
        billToMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'BILL_TO' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === 'TEMPLATES' 
            )?.ruleValue ?? NOT_MANDATORY,
        careOfFieldVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CARE_OF_FIELD' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' 
            )?.ruleValue || NOT_VISIBLE,
        careOfFieldMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CARE_OF_FIELD' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === 'TEMPLATES' 
            )?.ruleValue ?? NOT_MANDATORY,
        shipToVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHIP_TO_FIELD' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.module === 'TEMPLATES' 
            )?.ruleValue || NOT_VISIBLE,
        shipToMandatory:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHIP_TO_FIELD' &&
                    data.ruleName === 'MANDATORY' &&
                    data.module === 'TEMPLATES' 
            )?.ruleValue ?? NOT_MANDATORY,
        billToShipToPartnerRole:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'SHIP_TO_PARTNER_ROLE' &&
                    data.ruleName === 'PARTNER_ASSIGNMENT' &&
                    data.module === 'TEMPLATES'
            )?.ruleValue || '',
    };
};

export const inventoryConfigRules = (configRulesDataList) => {
    return {
        inventoryVisibility: getInventoryVisibility(configRulesDataList),
    };
};

export const getOrderTypeVisibility = (configRulesDataList) => {
    return {
        ALL_ORDERS_Visibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'ALL_ORDERS'
            )?.ruleValue ?? NOT_VISIBLE,
        ZLB_OrderTypeVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'ZLB'
            )?.ruleValue ?? NOT_VISIBLE,
        ZLC_OrderTypeVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'ZLC'
            )?.ruleValue ?? NOT_VISIBLE,
        MAST_OrderTypeVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'MAST'
            )?.ruleValue ?? NOT_VISIBLE,
        ZOR_OrderTypeVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'ZOR'
            )?.ruleValue ?? NOT_VISIBLE,
        ZKA_L2_KR_G2_ZRE_OrderTypeVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'ZKA,L2,KR,G2,ZRE'
            )?.ruleValue ?? NOT_VISIBLE,
        KB_KE_OrderTypeVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'KB,KE'
            )?.ruleValue ?? NOT_VISIBLE,
        Draft_ORDERS_Visibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === '20010'
            )?.ruleValue ?? NOT_VISIBLE,
    };
};

export const getSettingFieldVisibility = (configRulesDataList) => {
    return {
        calendarSettingVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CALENDAR_SETTING' &&
                    data.module === 'SETTINGS' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
        unidPlanUpdatesVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'UNIDPLANUPDATES' &&
                    data.module === 'SETTINGS' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
        notificationSettingVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'NOTIFICATION_SETTING' &&
                    data.module === 'SETTINGS' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
    };
};

export const menuConfigRules = (configRulesDataList) => {
    return {
        createOrderDetails: getCreateOrderDetails(configRulesDataList || []),
        moreVisibility: getMoreModuleVisibility(configRulesDataList || []),
        mainMenuVisibility: getMainMenuVisibility(configRulesDataList || []),
        orderTypeVisibilityConfig: getOrderTypeVisibility(
            configRulesDataList || []
        ),
        settingFieldVisibilityConfig: getSettingFieldVisibility(
            configRulesDataList || []
        ),
        awaitingPoVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'AWAITING_PO' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue ?? NOT_VISIBLE,
        calendarPage:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'CREATE' &&
                    data.module === 'CALENDAR' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZLC'
            )?.ruleValue ?? NOT_VISIBLE,
        physicianDropdownZGMorePhysicianVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'MORE' &&
                    data.ruleName === 'VISIBILITY'
            )[0]?.ruleValue || ENABLED,
        physicianDropdownZGMorePhysicianMandatory: configRulesDataList?.filter(
            (data) =>
                data.feature === 'PHYSICIAN_PARTNER' &&
                data.module === 'MORE' &&
                data.ruleName === 'MANDATORY'
        )[0]?.ruleValue,
        deliveryCheckEdit: configRulesDataList?.filter((data) => {
            return (
                data.uid === '1601' &&
                data.salesOrg === 'S024' &&
                data.metadata === 'CTA_005' &&
                data.feature === 'ACTION' &&
                data.ruleName === 'DELIVERY_CHECK'
            );
        })[0]?.ruleValue,
        deliveryCheckNoUsageToReport: configRulesDataList?.filter((data) => {
            return (
                data.uid === '1602' &&
                data.salesOrg === 'S024' &&
                data.metadata === 'CTA_007' &&
                data.feature === 'ACTION' &&
                data.ruleName === 'DELIVERY_CHECK'
            );
        })[0]?.ruleValue,
        notificationFailureFilterVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'FILTER' &&
                    data.module === 'ORDERS' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.metadata === 'Notification Failure'
            )?.ruleValue ?? NOT_VISIBLE,
    };
};

const setConfigRules = (configRulesDataList) => {
    return {
        // shipDontShipSurgery:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SHIP_DONTSHIP' &&
        //             data.module === 'SCHEDULE_SURGERY'
        //     ).length > 0
        //         ? configRulesDataList?.filter(
        //             (data) =>
        //                 data.feature === 'SHIP_DONTSHIP' &&
        //                 data.module === 'SCHEDULE_SURGERY'
        //         )[0].ruleValue
        //         : ENABLED,
        // this below poSurgeryVisibility config will be removed in SP4 story
        poSurgeryVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PURCHASE_ORDER' &&
                    data.module === 'SCHEDULE_SURGERY' &&
                    data.ruleName === 'VISIBILITY'
            )[0]?.ruleValue || ENABLED,
        poSurgeryMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PURCHASE_ORDER' &&
                    data.module === 'SCHEDULE_SURGERY' &&
                    data.ruleName === 'MANDATORY'
            )[0]?.ruleValue === 'YES',
        patientInformationVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PATIENT_INFORMATION' &&
                    data.ruleName === 'VISIBILITY'
            )[0]?.ruleValue || VISIBLE,
        patientIdVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PATIENT_ID' &&
                    data.ruleName === 'VISIBILITY'
            )[0]?.ruleValue || VISIBLE,
        patientIdMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PATIENT_ID' &&
                    data.ruleName === 'MANDATORY'
            )[0]?.ruleValue === MANDATORY,
        // physicianTextConsignmentAddVisibility:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'PHYSICIAN_FIELD_TEXT' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || ENABLED,
        physicianTextConsignmentAddMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.module === 'CONSIGNMENT_ADD' &&
                    data.ruleName === 'MANDATORY'
            )[0]?.ruleValue === MANDATORY,
        // physicianTextConsignmentBillingVisibility:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'PHYSICIAN_FIELD_TEXT' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || ENABLED,
        physicianTextConsignmentBillingMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_FIELD_TEXT' &&
                    data.module === 'CONSIGNMENT_BILLING' &&
                    data.ruleName === 'MANDATORY'
            )[0]?.ruleValue === MANDATORY,
        physicianDropdownZGMASTVisibility: configRulesDataList?.filter(
            (data) =>
                data.feature === 'PHYSICIAN_PARTNER' &&
                data.module === 'MAST' &&
                data.ruleName === 'VISIBILITY' &&
                data.orderType === 'ZLC'
        )[0]?.ruleValue,
        physicianDropdownZGMASTMandatory: configRulesDataList?.filter(
            (data) =>
                data.feature === 'PHYSICIAN_PARTNER' &&
                data.module === 'MAST' &&
                data.ruleName === 'MANDATORY' &&
                data.orderType === 'ZLC'
        )[0]?.ruleValue,
        //ConsignmentAdd
        physicianDropdownZGConsignmentAddVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'CONSIGNMENT_ADD' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'KB'
            )[0]?.ruleValue,
        physicianDropdownZGConsignmentAddMandatory: configRulesDataList?.filter(
            (data) =>
                data.feature === 'PHYSICIAN_PARTNER' &&
                data.module === 'CONSIGNMENT_ADD' &&
                data.ruleName === 'MANDATORY' &&
                data.orderType === 'KB'
        )[0]?.ruleValue,
        // consignmentBilling
        physicianDropdownZGConsignmentBillingVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'CONSIGNMENT_BILLING' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'KE'
            )[0]?.ruleValue,
        physicianDropdownZGConsignmentBillingMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'CONSIGNMENT_BILLING' &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'KE'
            )[0]?.ruleValue,
        // equity
        physicianDropdownZGEquityVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'EQUITY' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'ZOR'
            )[0]?.ruleValue || ENABLED,
        physicianDropdownZGEquityMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'EQUITY' &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'ZOR'
            )[0]?.ruleValue || 'NO',
        // ConsignmentBillingReplenishment
        physicianDropdownZGConsignmentBillingReplenishmentVisibility:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'CONSIGNMENT_REPLENISHMENT' &&
                    data.ruleName === 'VISIBILITY' &&
                    data.orderType === 'KB'
            )[0]?.ruleValue || 'NOT_VISIBLE',
        physicianDropdownZGConsignmentBillingReplenishmentMandatory:
            configRulesDataList?.filter(
                (data) =>
                    data.feature === 'PHYSICIAN_PARTNER' &&
                    data.module === 'CONSIGNMENT_REPLENISHMENT' &&
                    data.ruleName === 'MANDATORY' &&
                    data.orderType === 'KB'
            )[0]?.ruleValue || 'NO',
        //More Physician

        //unknown Physician
        // unknownPhysicianVisibility:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'UNKNOWN_PHYSICIAN' &&
        //             data.module === 'SCHEDULE_SURGERY' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.orderType === 'ZLC'
        //     )[0]?.ruleValue ?? NOT_VISIBLE,
        // afterHourMessageStartTime:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'AFTER_HOUR_MESSAGING' &&
        //             data.ruleName === 'HOUR_START_TIME'
        //     )[0]?.metadata || '',
        // afterHourMessageEndTime:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'AFTER_HOUR_MESSAGING' &&
        //             data.ruleName === 'HOUR_END_TIME'
        //     )[0]?.metadata || '',
        // afterHourMessageVisibility:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'AFTER_HOUR_MESSAGING' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'DISABLED',
        // emeaSurgeryPopup:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'EMEA_SURGERY_POPUP' &&
        //             data.module === 'SCHEDULE_SURGERY' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || ENABLED,
        // salesOrg:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.module === 'ORDERS' &&
        //             data.feature === 'CREATE' &&
        //             data.orderType === 'KE' &&
        //             data.metadata === 'Consignment Billing'
        //     )?.characteristicValue || null,
        // removeExtraItem: configRulesDataList
        //     ?.filter(
        //         (data) =>
        //             data.feature === 'TEMPLATE_ADD_PRODUCT' &&
        //             data.module === 'TEMPLATES' &&
        //             data.ruleName === 'VISIBILITY'
        //     )
        //     .map((item) => ({
        //         [item.characteristicValue]: item.ruleValue,
        //     }))
        //     .reduce((prev, curr) => ({ ...prev, ...curr }), {}),
        physicianFinderEligibilityEquity: filterObject(
            configRulesDataList,
            'physicianFinderEligibility',
            true
        ),

        patient_Details: filterObject(configRulesDataList, 'patient_Details'),
        patient_DetailsMandatory: filterObject(
            configRulesDataList,
            'patient_DetailsMandatory'
        ),
        surgeryPatientDetails: filterObject(
            configRulesDataList,
            'surgeryPatientDetails'
        ),
        surgeryPatientDetailsMandatory: filterObject(
            configRulesDataList,
            'surgeryPatientDetailsMandatory'
        ),

        // additionalProcedureEquity: filterObject(
        //     configRulesDataList,
        //     'additionalProcedure',
        //     true
        // ),

        // deformityCorrectionEquity: filterObject(
        //     configRulesDataList,
        //     'deformityCorrection',
        //     true
        // ),

        // biologicsUsedEquity: filterObject(
        //     configRulesDataList,
        //     'biologicsUsed',
        //     true
        // ),

        // procedureDataPhysicianEquity: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'PROCEDURE_DATA_PHYSICIAN' &&
        //         data.module === 'EQUITY' &&
        //         data.ruleName === 'VISIBILITY' &&
        //         (data.ruleValue === 'NOT_VISIBLE' ||
        //             data.ruleValue === 'ENABLED')
        // )?.ruleValue,
        // advancedEnergyEquity: filterObject(
        //     configRulesDataList,
        //     'advancedEnergy',
        //     true
        // ),

        // retractorUsedEquity: filterObject(
        //     configRulesDataList,
        //     'retractorUsed',
        //     true
        // ),

        // biologicsDetailEquity: filterObject(
        //     configRulesDataList,
        //     'biologicsDetail',
        //     true
        // ),

        isHeaderCondensedView:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'DEFAULT_CONDENSED_VIEW' &&
                    data.characteristic === 'SALESORG' &&
                    data.characteristicValue === 'S024' &&
                    data.ruleName === 'CONDENSED_VIEW_TOGGLE'
            )?.ruleValue === 'ENABLED'
                ? true
                : false,

        // procedureTypeConsignmentAdd:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PROCEDURE_TYPE' &&
        //             data.module === 'ORDERS' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.orderType === 'KB'
        //     )?.ruleValue || 'NOT_VISIBLE',
        // procedureTypeConsignmentAddMandatory:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PROCEDURE_TYPE' &&
        //             data.module === 'ORDERS' &&
        //             data.ruleName === 'MANDATORY' &&
        //             data.orderType === 'KB'
        //     )?.ruleValue || 'NO',
        procedureEquityPageVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'PROCEDURE_PAGE' &&
                    data.module === 'EQUITY' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue === 'NOT_VISIBLE'
                ? false
                : true,
        // surgeryNumberSurgeryVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'SURGERY_NUMBER' &&
        //         data.module === 'SCHEDULE_SURGERY' &&
        //         data.ruleName === 'VISIBILITY' &&
        //         data.orderType === 'ZLC'
        // )?.ruleValue,
        // surgeryNumberSurgeryMandatory: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'SURGERY_NUMBER' &&
        //         data.module === 'SCHEDULE_SURGERY' &&
        //         data.ruleName === 'MANDATORY' &&
        //         data.orderType === 'ZLC'
        // )?.ruleValue,
        // surgeryNumberMASTVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'SURGERY_NUMBER' &&
        //         data.module === 'MAST' &&
        //         data.ruleName === 'VISIBILITY' &&
        //         data.orderType === 'ZLC'
        // )?.ruleValue,
        // surgeryNumberMASTMandatory: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'SURGERY_NUMBER' &&
        //         data.module === 'MAST' &&
        //         data.ruleName === 'MANDATORY' &&
        //         data.orderType === 'ZLC'
        // )?.ruleValue,
        // surgeryNumberConsignmentAddVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'SURGERY_NUMBER' &&
        //         data.module === 'ORDERS' &&
        //         data.ruleName === 'VISIBILITY' &&
        //         data.orderType === 'KB'
        // )?.ruleValue,
        // surgeryNumberConsignmentAddMandatory: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'SURGERY_NUMBER' &&
        //         data.module === 'ORDERS' &&
        //         data.ruleName === 'MANDATORY' &&
        //         data.orderType === 'KB'
        // )?.ruleValue,
        surgeryNumberConsignmentBillingVisibility: configRulesDataList?.find(
            (data) =>
                data.feature === 'SURGERY_NUMBER' &&
                data.module === 'ORDERS' &&
                data.ruleName === 'VISIBILITY' &&
                data.orderType === 'KE'
        )?.ruleValue,
        surgeryNumberConsignmentBillingMandatory: configRulesDataList?.find(
            (data) =>
                data.feature === 'SURGERY_NUMBER' &&
                data.module === 'ORDERS' &&
                data.ruleName === 'MANDATORY' &&
                data.orderType === 'KE'
        )?.ruleValue,
        // priceOverrideEquityVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'PRICE_OVERRIDE' &&
        //         data.module === 'EQUITY' &&
        //         data.ruleName === 'VISIBILITY' &&
        //         data.orderType === 'ZOR'
        // )?.ruleValue,
        // priceOverrideConsignmentBillingVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'PRICE_OVERRIDE' &&
        //         data.module === 'CONSIGNMENT_BILLING' &&
        //         data.ruleName === 'VISIBILITY' &&
        //         data.orderType === 'KE'
        // )?.ruleValue,

        // billToEquityVisibility:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'BILL_TO' &&
        //             data.module === 'EQUITY' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.orderType === 'ZOR'
        //     )?.ruleValue || 'NOT_VISIBLE',

        // billToEquityMandatory:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'BILL_TO' &&
        //             data.module === 'EQUITY' &&
        //             data.ruleName === 'MANDATORY' &&
        //             data.orderType === 'ZOR'
        //     )?.ruleValue || 'NO',
        // procedureTypeEquityMandatoryRule:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PROCEDURE_TYPE' &&
        //             data.module === 'EQUITY' &&
        //             data.ruleName === 'MANDATORY'
        //     )?.ruleValue || NOT_MANDATORY,
        // procedureTypeEquityVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'PROCEDURE_TYPE' &&
        //         data.module === 'EQUITY' &&
        //         data.ruleName === 'VISIBILITY'
        // )?.ruleValue || NOT_VISIBLE,

        // billToConsignmentBillingVisibility:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'BILL_TO' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.orderType === 'KE'
        //     )?.ruleValue || 'NOT_VISIBLE',

        // billToConsignmentBillingMandatory:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'BILL_TO' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'MANDATORY' &&
        //             data.orderType === 'KE'
        //     )?.ruleValue || 'NO',

        // billToConsignmentAddVisibility:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'BILL_TO' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.orderType === 'KB'
        //     )?.ruleValue || 'NOT_VISIBLE',

        // billToConsignmentAddMandatory:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'BILL_TO' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'MANDATORY' &&
        //             data.orderType === 'KB'
        //     )?.ruleValue || 'NO',

        // billToShipToPartnerRole:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'SHIP_TO_PARTNER_ROLE' &&
        //             data.module === 'SHIP_TO_PARTNER_ROLE' &&
        //             data.ruleName === 'PARTNER_ASSIGNMENT'
        //     )?.ruleValue || '',

        // billToVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'SHIP_TO_PARTNER_ROLE' &&
        //         data.module === 'SHIP_TO_PARTNER_ROLE' &&
        //         data.ruleName === 'PARTNER_ASSIGNMENT'
        // )?.ruleValue,
        // requestedDeliveryDateVisibilityKE: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'REQUESTED_DELIVERY_DATE' &&
        //         data.module !== 'REPLENISHMENT' &&
        //         data.ruleName === 'VISIBILITY'
        // )?.ruleValue,
        // requestedDeliveryDateMandatoryKE: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'REQUESTED_DELIVERY_DATE' &&
        //         data.module !== 'REPLENISHMENT' &&
        //         data.ruleName === 'MANDATORY'
        // )?.ruleValue,
        // requestedDeliveryDateVisibility:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'RDD_DATE' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY'
        //     )?.ruleValue || 'VISIBLE',
        // requestedDeliveryDateMandatoryKB:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'RDD_DATE' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'MANDATORY'
        //     )?.ruleValue || 'YES',
        // consignmentBillingPaymentVisibility:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'PAYMENT_INFORMATION' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || ENABLED,
        // transferRecipientVisibility:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'TRANSFER_RECIPIENT' &&
        //             data.module === 'ORDERS' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // careOfFieldVisibilityKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'CARE_OF_FIELD' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // careOfFieldVisibilityKE:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'CARE_OF_FIELD' &&
        //             data.module === 'CONSIGNMENT_REPLENISHMENT' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // specialStockPartnerVisibilityKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SPECIAL_STOCK_PARTNER' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // specialStockPartnerMandatoryKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SPECIAL_STOCK_PARTNER' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'MANDATORY'
        //     )[0]?.ruleValue || 'NO',
        // purchaseOrderVisibilityKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'PURCHASE_ORDER' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'VISIBLE',
        // shortTermConsignmentVisibilityKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SHORT_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // longTermConsignmentVisibilityKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'LONG_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // shortTermConsignmentMandatoryKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SHORT_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'MANDATORY'
        //     )[0]?.ruleValue || 'NO',
        // longTermConsignmentMandatoryKB:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'LONG_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_ADD' &&
        //             data.ruleName === 'MANDATORY'
        //     )[0]?.ruleValue || 'NO',
        // specialStockPartnerVisibilityKE:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SPECIAL_STOCK_PARTNER' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // // procedureVisibilityKE:
        // //     configRulesDataList?.filter(
        // //         (data) =>
        // //             data.feature === 'PROCEDURE_TYPE' &&
        // //             data.module === 'ORDERS' &&
        // //             data.orderType === 'KE' &&
        // //             data.ruleName === 'VISIBILITY'
        // //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // // procedureMandatoryKE:
        // //     configRulesDataList?.filter(
        // //         (data) =>
        // //             data.feature === 'PROCEDURE_TYPE' &&
        // //             data.module === 'ORDERS' &&
        // //             data.orderType === 'KE' &&
        // //             data.ruleName === 'MANDATORY'
        // //     )[0]?.ruleValue || 'NO',
        // specialStockPartnerMandatoryKE:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SPECIAL_STOCK_PARTNER' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'MANDATORY'
        //     )[0]?.ruleValue || 'NO',
        // shortTermConsignmentVisibilityKE:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SHORT_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // longTermConsignmentVisibilityKE:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'LONG_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'VISIBILITY'
        //     )[0]?.ruleValue || 'NOT_VISIBLE',
        // shortTermConsignmentMandatoryKE:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'SHORT_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'MANDATORY'
        //     )[0]?.ruleValue || 'NO',
        // longTermConsignmentMandatoryKE:
        //     configRulesDataList?.filter(
        //         (data) =>
        //             data.feature === 'LONG_TERM_CONSIGNEMNT' &&
        //             data.module === 'CONSIGNMENT_BILLING' &&
        //             data.ruleName === 'MANDATORY'
        //     )[0]?.ruleValue || 'NO',
        // implantDateVisibility: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'IMPLANT_DATE' &&
        //         data.module === 'ORDERS' &&
        //         data.ruleName === 'VISIBILITY' &&
        //         data.orderType === 'KB'
        // )?.ruleValue,
        // implantDateMandatory: configRulesDataList?.find(
        //     (data) =>
        //         data.feature === 'IMPLANT_DATE' &&
        //         data.module === 'ORDERS' &&
        //         data.ruleName === 'MANDATORY' &&
        //         data.orderType === 'KB'
        // )?.ruleValue,
        // requestedDeliveryDateCutOffTime: configRulesDataList?.find(
        //     (data) => data.feature === 'RDD_CUTOFFTIME'
        // )?.metadata,
        //Product Type
        // productTypeVisibilityKE:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PRODUCT_TYPE' &&
        //             data.ruleName === 'VISIBILITY' &&
        //             data.orderType === 'KE'
        //     )?.ruleValue || 'VISIBLE',
        // productTypeMandatoryKE:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'PRODUCT_TYPE' &&
        //             data.ruleName === 'MANDATORY' &&
        //             data.orderType === 'KE'
        //     )?.ruleValue || 'YES',
        // allDayRequestedDeliveryDate:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'RDD_ALLDAY' &&
        //             data.ruleName === 'VISIBILITY'
        //     )?.ruleValue || DISABLED,
        // enableRequestedDeliveryDateForWeekEnd:
        //     configRulesDataList?.find(
        //         (data) =>
        //             data.feature === 'RDD_WEEKEND' &&
        //             data.ruleName === 'VISIBILITY'
        //     )?.ruleValue || DISABLED,
        usageReplenishmentSurgeryDateVisibility:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'REPLENISHMENT_SURGERY_DATE' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR' &&
                    data.ruleName === 'VISIBILITY'
            )?.ruleValue || DISABLED,
        usageReplenishmentSurgeryDateMandatoryRule:
            configRulesDataList?.find(
                (data) =>
                    data.feature === 'REPLENISHMENT_SURGERY_DATE' &&
                    data.module === 'REPLENISHMENT' &&
                    data.orderType === 'ZLCR' &&
                    data.ruleName === 'MANDATORY'
            )?.ruleValue || 'NO',
    };
};
//This function is used to set the config rules based on the option chosen
export const setActionCall = (
    option,
    configRulesDataList,
    orderType = null
) => {
    switch (option) {
        case MENU:
            return menuConfigRules(configRulesDataList);
        case SCHEDULE_SURGERY:
            return getOrderFlowConfigRules(configRulesDataList, option);
        case MAST:
            return getOrderFlowConfigRules(configRulesDataList, option);
        case INVENTORY:
            return inventoryConfigRules(configRulesDataList);
        case CONSIGNMENT_BILLING:
            return getOrderFlowConfigRules(configRulesDataList, option);
        case CONSIGNMENT_ADD:
            return getOrderFlowConfigRules(configRulesDataList, option);
        case EQUITY:
            return getOrderFlowConfigRules(configRulesDataList, option);
        case REPORT_USAGE:
            return getUsageConfigRules(configRulesDataList, option);
        case SETTINGS:
            return getSettingsConfigRules(configRulesDataList, option);
        case ORDERS:
            return getOrderFlowConfigRules(
                configRulesDataList,
                option,
                orderType
            );
        case TEMPLATES:
            return getTemplatesConfigRules(configRulesDataList, orderType);
        case REPORT_PROCEDURE_DATA:
            return getReportProcedureDataConfigRules(configRulesDataList);
        case CONSIGNMENT_RETURN:
            return getConsignmentReturnConfigRules(configRulesDataList, option);
        case NO_USAGE_REPORT:
            return getNoUsageToReportConfig(configRulesDataList);
        case PROXY:
            return getProxyConfig(configRulesDataList);
        default:
            return initialState;
    }
};
const LoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload,
            };
        case SET_IS_AUTHENTICATED_WITH_HYBRIS:
            return {
                ...state,
                isAuthenticatedWithHybris: action.payload,
            };
        case GET_HYBRIS_USER_DETAILS_LOADING:
        case GET_HYBRIS_USER_DETAILS:
            return {
                ...state,
                loading: true,
                userDetailsLoading: true,
            };
        case GET_HYBRIS_USER_DETAILS_SUCCESS: {
            return {
                ...state,
                loading: false,
                userDetailsLoading: false,
                hybrisUserDetails: {
                    countryISOCode: US_COUNTRY_CODE,
                    ...action.payload,
                },
                salesOrg: Array.isArray(action.payload?.salesOrgs)
                    ? action.payload.salesOrgs[0]
                    : '',
                allSalesOrg: action?.payload?.salesOrgs,
                isLanguageChanged: action.payload.isLanguageChanged || false,
                ...setConfigRules(action.payload.configRulesDataList || []),
            };
        }
        case GET_HYBRIS_USER_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                userDetailsLoading: false,
                hybrisUserDetails: { employeeRole: null },
            };
        case LOGIN:
            return {
                ...state,
                loginLoading: true,
                loginError: '',
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                loginLoading: false,
                loginError: '',
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                loginLoading: false,
                loginError: action.payload || '',
            };
        case GET_CONFIGURATION:
            return {
                ...state,
                loading: action.payload.optionChosen === ORDERS ? false : true,
                userDetailsLoading:
                    action.payload.optionChosen === ORDERS
                        ? false
                        : action.payload.optionChosen === TEMPLATES
                        ? false
                        : true,
            };
        case GET_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                loading: false,
                userDetailsLoading: false,
                configRule: action.payload,
                ...setActionCall(
                    action.payload.optionChosen,
                    action.payload.configRulesDataList,
                    action.payload.orderType
                ),
            };
        }
        case GET_CONFIGURATION_FAILURE:
            return {
                ...state,
                loading: false,
                userDetailsLoading: false,
            };
        case SET_LOGOUT:
            return {
                ...state,
                loggingOut: true,
                logoutStatusCode: '0',
            };
        case SET_MAST_ORDER:
            return {
                ...state,
                isMastOrder: action.payload,
            };
        case SET_LOGOUT_SUCCESS:
            return {
                ...state,
                loggingOut: false,
                logoutStatusCode: action.payload.statusCode || '10011',
                bannerInfo: [],
                bannerLength: 0,
                bannerFrequency: undefined,
                infoBanner: [],
                confirmationBanner: [],
                showDismissedBanner: false,
                isDestructiveEnabled: false,
            };
        case RESET_BANNERS:
            return{
                ...state,
                 bannerInfo: [],
                 bannerLength: 0,
                bannerFrequency: undefined,
                infoBanner: [],
                confirmationBanner: [],
                showDismissedBanner: false,
                isDestructiveEnabled: false,
            }

        case SET_LOGOUT_FAILURE:
            return {
                ...state,
                loggingOut: false,
                logoutStatusCode: action.payload.statusCode,
            };
        case SET_LOGOUT_SSO:
            return {
                ...state,
                loggingOutSSO: action.payload,
                bannerInfo: [],
                bannerLength: 0,
                bannerFrequency: undefined,
                infoBanner: [],
                confirmationBanner: [],
                showDismissedBanner: false,
                isDestructiveEnabled: false,
            };
        case GET_BANNER_DETAILS:
            return {
                ...state,
                loading: true,
                bannerInfo: [],
                bannerLength: 0,
            };
        case GET_BANNER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                bannerInfo: action.payload ? action.payload : [],
            };
        case GET_BANNER_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                bannerInfo: [],
                bannerLength: 0,
            };
        case GET_BANNER_LENGTH:
            return {
                ...state,
                bannerLength: getBannerLength(action.payload),
            };
        case SET_BANNER_FREQUECY:
            return {
                ...state,
                bannerFrequency: action?.payload ? action.payload : 300,
            };
        case SHOW_DISMISSED_BANNER:
            return {
                ...state,
                showDismissedBanner: true,
            };
        case HIDE_DISMISSED_BANNER:
            return {
                ...state,
                showDismissedBanner: false,
            };
        case SET_BANNER_HEIGHT:
            return {
                ...state,
                bannerHeight: action?.payload ? action?.payload : '',
            };
        case SET_FORBIDDEN_ERROR_CHECK_VALUE:
            return {
                ...state,
                isForbidden: action.payload,
            };
        case SET_CONFIG_TABLE_RULES:
            return {
                ...state,
                hybrisUserDetails: {
                    ...state.hybrisUserDetails,
                    countryISOCode: action.countryISOCode,
                },
                salesOrg: action.salesOrgs[0],
                allSalesOrg: action.salesOrgs,
                isLanguageChanged: action.isLanguageChanged || false,
                ...setConfigRules(action.payload || []),
            };
        case SET_BANNER_DETAILS:
            return {
                ...state,
                infoBanner: action.payload,
            };
        case SET_CONFIRMATION_BANNER:
            return {
                ...state,
                confirmationBanner: action.payload,
            };
        case SET_DESTRUCTIVE:
            return {
                ...state,
                isDestructiveEnabled: action.payload,
            };
        case IS_CONDENSED_VIEW:
            return {
                ...state,
                isCondensedView: action.payload,
            };
        case IS_HEADER_CONDENSED_VIEW:
            return {
                ...state,
                isHeaderCondensedView: action.payload,
            };
        case IS_HIDE_CONDENSED_VIEW:
            return {
                ...state,
                hideCondensedViewToggle: action.payload,
            };
        case SET_PEDIATRIC_CHECK:
            return {
                ...state,
                pediatricCheck: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

const getBannerLength = (payload = []) => {
    const isDestructive =
        payload &&
        !checkProxyActive() &&
        !checkImpersonationActive() &&
        payload.filter((item) => item.messageType === 'userDestructiveMessage')
            .length > 0;
    return !isDestructive && payload
        ? payload.filter((item) => item.messageType === 'userInfoMessage')
              .length
        : 0;
};

export default persistReducer(
    {
        key: 'loginKey',
        storage: storage,
        whitelist: [
            // Banner data (bannerInfo/bannerLength/bannerHeight) is intentionally
            // NOT persisted. It is always fetched fresh via getBannerDetails() after
            // login and recomputed at runtime. Persisting it caused persist/REHYDRATE
            // to restore a stale banner after logout (the reload fires before the
            // cleared banner is flushed to storage), showing the banner post-logout.
            'inventoryVisibility',
            'moreVisibility',
            'createOrderDetails',
            'mainMenuVisibility',
            'salesOrg',
            'allSalesOrg',
            'removeExtraItem',
            'currentDateDelivery',
            //uasge procedure page fileds visibilty
            'additionalProcedure',
            'biologicsDetail',
            'deformityCorrection',
            'physicianFinderEligibility',
            'procedureDataPhysician',
            'biologicsUsed',
            'retractorUsed',
            'advancedEnergy',
            //uasge procedure page fileds visibilty
            'additionalProcedureEquity',
            'biologicsDetailEquity',
            'deformityCorrectionEquity',
            'physicianFinderEligibilityEquity',
            'procedureDataPhysicianEquity',
            'biologicsUsedEquity',
            'retractorUsedEquity',
            'advancedEnergyEquity',
            //Start - Patient Details Visibility and mandatory
            'reportUsagePatientDetails',
            'reportUsagePatientDetailsMandatory',
            'patient_Details',
            'patient_DetailsMandatory',
            'patientInformationVisibility',
            'patientIdVisibility',
            'surgeryPatientDetails',
            'surgeryPatientDetailsMandatory',
            //End - Patient Details Visibility and mandatory
            'procedureTypeConsignmentAdd',
            'procedureTypeConsignmentAddMandatory',
            'isMastOrder',
            'requestedDeliveryDateVisibility',
            'requestedDeliveryDateMandatory',
            'requestedDeliveryDateVisibilityKB',
            'requestedDeliveryDateMandatoryKB',
            'procedurePageVisibility',
            'procedureEquityPageVisibility',
            'surgeryNumberVisibility',
            'surgeryNumberMASTVisibility',
            'surgeryNumberConsignmentAddVisibility',
            'surgeryNumberConsignmentBillingVisibility',
            'surgeryNumberUsageReplenishmentVisibility',
            'surgeryNumberReportUsageVisibility',
            'surgeryNumberMandatory',
            'surgeryNumberMASTMandatory',
            'surgeryNumberConsignmentAddMandatory',
            'surgeryNumberConsignmentBillingMandatory',
            'surgeryNumberUsageReplenishmentMandatory',
            'surgeryNumberReportUsageMandatory',
            //'billToEquityVisibility',
            // 'billToEquityMandatory',
            'billToConsignmentBillingVisibility',
            'billToConsignmentBillingMandatory',
            'billToConsignmentAddVisibility',
            'billToConsignmentAddMandatory',
            'billToScheduleSurgeryVisibility',
            'billToScheduleSurgeryMandatory',
            'billToReportUsageVisibility',
            'billToReportUsageMandatory',
            'billToConsignmentReturnVisibility',
            'billToConsignmentReturnMandatory',
            'billToShipToPartnerRole',
            //ZG PARTNER
            //Surgery
            'physicianDropdownZGSurgeryVisibility',
            'physicianDropdownZGSurgeryMandatory',
            'physicianTextSurgeryVisibility',
            'physicianTextSurgeryMandatory',
            'physicianDropdownSurgeryMandatory',
            'physicianDropdownSurgeryVisibility',
            //MAST
            'physicianDropdownZGMASTVisibility',
            'physicianDropdownZGMASTMandatory',
            //ConsignmentAdd
            'physicianDropdownZGConsignmentAddVisibility',
            'physicianDropdownZGConsignmentAddMandatory',
            // consignmentBilling
            'physicianDropdownZGConsignmentBillingVisibility',
            'physicianDropdownZGConsignmentBillingMandatory',
            // ReportUsage
            'physicianDropdownZGReportUsageVisibility',
            'physicianDropdownZGReportUsageMandatory',
            'physicianTextUsageVisibility',
            'physicianTextUsageMandatory',
            // equity
            'physicianDropdownZGEquityVisibility',
            'physicianDropdownZGEquityMandatory',
            // ReportUsageReplenishment
            'physicianDropdownZGReportUsageReplenishmentVisibility',
            'physicianDropdownZGReportUsageReplenishmentMandatory',
            //ConsignmentBillingReplenishment
            'physicianDropdownZGConsignmentBillingReplenishmentVisibility',
            'physicianDropdownZGConsignmentBillingReplenishmentMandatory',
            //More Physician
            'physicianDropdownZGMorePhysicianVisibility',
            //Unknown Physician
            'unknownPhysicianVisibility',
            'reportUsagePatientDetails',
            'settingsAlternateEmailVisibility',
            'deliveryCheckEdit',
            'deliveryCheckNoUsageToReport',
            'levelsUsed',
            'levelsUsedEquity',
            'billToVisibility',
            'billToMandatory',
            'requestedDeliveryDateVisible',
            'requestedDeliveryDateVisibilityKE',
            'requestedDeliveryDateMandatoryKE',
            'attnFieldVisibility',
            'transferRecipientVisibility',
            'careOfFieldVisibility',
            'careOfFieldMandatory',
            'shipToFieldVisibility',
            'careOfFieldVisibilityZLC',
            'careOfFieldVisibilityKB',
            'careOfFieldVisibilityKE',
            'careOfFieldVisibilityZLCR',
            'specialStockPartnerVisibilityKB',
            'specialStockPartnerMandatoryKB',
            'purchaseOrderVisibilityKB',
            'shortTermConsignmentVisibilityKB',
            'longTermConsignmentVisibilityKB',
            'shortTermConsignmentMandatoryKB',
            'longTermConsignmentMandatoryKB',
            'implantDateMandatory',
            'implantDateVisibility',
            'specialStockPartnerVisibilityKE',
            'specialStockPartnerMandatoryKE',
            'shortTermConsignmentVisibilityKE',
            'longTermConsignmentVisibilityKE',
            'shortTermConsignmentMandatoryKE',
            'longTermConsignmentMandatoryKE',
            'procedureMandatoryKE',
            'procedureVisibilityKE',
            'requestedDeliveryDateCutOffTime',
            'productTypeVisibility',
            'productTypeMandatory',
            //condensedViewState
            'isCondensedView',
            'isHeaderCondensedView',
            'allDayRequestedDeliveryDate',
            'enableRequestedDeliveryDateForWeekEnd',
            'usageReplenishmentSurgeryDateVisibility',
            'usageReplenishmentSurgeryDateMandatoryRule',
            'requestedDeliveryDateMandatoryZLC',
            'surgeryDeliveryDateVisibilityRule',
            'procedureVisibility',
            'procedureMandatory',
            'specialStockPartnerVisibility',
            'specialStockPartnerMandatory',
            'shortTermConsignmentVisibility',
            'longTermConsignmentVisibility',
            'shortTermConsignmentMandatory',
            'longTermConsignmentMandatory',
            'surgeryNumberReplenishmentVisibility',
            'surgeryNumberReplenishmentMandatory',
            'physicianTextVisibility',
            'patientDetailsVisibility',
            'patientDetailsMandatory',
            'physicianDropdownVisibility',
            'physicianDropdownyMandatory',
            'physicianDropdownZGVisibility',
            'physicianDropdownZGMandatory',
            'physicianDropdownZGReplenishmentVisibility',
            'physicianDropdownZGReplenishmentMandatory',
            'procedureTypeUsageVisibility',
            'procedureTypeEquityVisibility',
            'procedureTypeUsageMandatoryRule',
            'procedureTypeEquityMandatoryRule',
            'pediatricCheck',
            'accountPhysicianAPIUsage',
            'accountPhysicianAPIReplenishment',
            'pediatricSurgery',
            'pediatricSurgeryMandatory',
            'signatureVisibilityUsage',
            'priceOverrideReasonVisibilityUsage',
            'priceOverrideReasonMandatoryUsage',
            'priceOverrideCommentsVisibilityUsage',
            'priceOverrideCommentsMandatoryUsage',
            'replenishmentPageVisibilityUsage',
            'priceOverrideVisibility',
            'competitorChosenVisibility',
            'usageViaEquityOrderVisibility',
            'instrumentOnlySurgeryVisibility',
            'surgeryVisualInspection',
            'calendarPage',
            'awaitingPoVisibility',
            'orderTypeVisibilityConfig',
            'settingFieldVisibilityConfig',
            'calendarSettingMetadata',
            'unidPlanUpdatesMetadata',
            'notificationSettingMetadata',
            'contactNameVisibility',
            'contactNameMandatory',
            'contactNumberVisibility',
            'contactNumberMandatory',
            'createTemplateVisibility',
            'notesVisibility',
            'addProductVisibility',
            'templateDropdownVisibility',
            'priceOverrideCommentsMandatory',
            'priceOverrideCommentsVisibility',
            'priceOverrideReasonMandatory',
            'priceOverrideReasonVisibility',
            'surgeryTemplateVisibility',
            'mastTemplateVisibility',
            'equityTemplateVisibility',
            'templateNotesVisibility',
            'templateProcedureVisibility',
            'templateProcedureMandatory',
            'addProductTemplateVisibility',
            'isShowBomChanges',
            'consignmentBillingPaymentVisibility',
            'proxyRadioButton',
            'proxyAutopopulateContactName',
            'transferRecipientMeta',
            'transferRecipientMandatory',
            'consignmentReportVisibility',
            'consignmentReportMandatory',
            'notificationFailureFilterVisibility',
            'physicianTextConsignmentAddVisibility',
            'physicianTextConsignmentAddMandatory',
            'reportUsageStealthAutoPilotVisibility',
            'reportUsageStealthLiveAlignVisibility',
        ],
    },
    LoginReducer
);
